// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[type='text'],input:where(:not([type])),[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, input:where(:not([type])):focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
  text-align: inherit;
}

::-webkit-datetime-edit {
  display: inline-flex;
}

::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

[multiple],[size]:where(select:not([size="1"])) {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@media (forced-colors: active)  {

  [type='checkbox']:checked {
    appearance: auto;
  }
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@media (forced-colors: active)  {

  [type='radio']:checked {
    appearance: auto;
  }
}

[type='checkbox']:checked:hover,[type='checkbox']:checked:focus,[type='radio']:checked:hover,[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media (forced-colors: active)  {

  [type='checkbox']:indeterminate {
    appearance: auto;
  }
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 1700px) {

  .container {
    max-width: 1700px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.\\!sticky {
  position: sticky !important;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!left-0 {
  left: 0px !important;
}
.\\!top-0 {
  top: 0px !important;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-\\[-0\\.75rem\\] {
  bottom: -0.75rem;
}
.bottom-\\[-1rem\\] {
  bottom: -1rem;
}
.end-1 {
  inset-inline-end: 0.25rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\/4 {
  left: 50%;
}
.left-44 {
  left: 11rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-auto {
  left: auto;
}
.left-full {
  left: 100%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\/2 {
  right: 50%;
}
.right-10 {
  right: 2.5rem;
}
.right-12 {
  right: 3rem;
}
.right-2 {
  right: 0.5rem;
}
.right-20 {
  right: 5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-\\[-1000px\\] {
  right: -1000px;
}
.right-\\[4px\\] {
  right: 4px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[5px\\] {
  top: 5px;
}
.top-\\[70px\\] {
  top: 70px;
}
.top-\\[78px\\] {
  top: 78px;
}
.top-auto {
  top: auto;
}
.top-full {
  top: 100%;
}
.\\!z-40 {
  z-index: 40 !important;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-10 {
  grid-column: span 10 / span 10;
}
.col-span-11 {
  grid-column: span 11 / span 11;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.col-span-7 {
  grid-column: span 7 / span 7;
}
.col-span-8 {
  grid-column: span 8 / span 8;
}
.col-span-9 {
  grid-column: span 9 / span 9;
}
.float-left {
  float: left;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-4 {
  margin: 1rem;
}
.m-\\[0\\.143rem\\] {
  margin: 0.143rem;
}
.m-auto {
  margin: auto;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.\\!mb-0 {
  margin-bottom: 0px !important;
}
.\\!mb-2 {
  margin-bottom: 0.5rem !important;
}
.\\!mt-0 {
  margin-top: 0px !important;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-0 {
  margin-left: -0px;
}
.-ml-0\\.5 {
  margin-left: -0.125rem;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-ml-1\\.5 {
  margin-left: -0.375rem;
}
.-ml-3 {
  margin-left: -0.75rem;
}
.-ml-4 {
  margin-left: -1rem;
}
.-ml-px {
  margin-left: -1px;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mr-7 {
  margin-right: -1.75rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-\\[-0\\.5715rem\\] {
  margin-bottom: -0.5715rem;
}
.mb-\\[2px\\] {
  margin-bottom: 2px;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-2\\.5 {
  margin-left: 0.625rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[-0\\.4715rem\\] {
  margin-left: -0.4715rem;
}
.ml-\\[-0\\.5715rem\\] {
  margin-left: -0.5715rem;
}
.ml-\\[-0\\.75rem\\] {
  margin-left: -0.75rem;
}
.ml-auto {
  margin-left: auto;
}
.ml-px {
  margin-left: 1px;
}
.mr-0 {
  margin-right: 0px;
}
.mr-0\\.5 {
  margin-right: 0.125rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-8 {
  margin-right: 2rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-0\\.5715rem\\] {
  margin-top: -0.5715rem;
}
.mt-\\[-0\\.5rem\\] {
  margin-top: -0.5rem;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.size-5 {
  width: 1.25rem;
  height: 1.25rem;
}
.\\!h-16 {
  height: 4rem !important;
}
.\\!h-\\[24px\\] {
  height: 24px !important;
}
.\\!h-screen {
  height: 100vh !important;
}
.h-0 {
  height: 0px;
}
.h-1 {
  height: 0.25rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[0\\.3rem\\] {
  height: 0.3rem;
}
.h-\\[1\\.143rem\\] {
  height: 1.143rem;
}
.h-\\[1\\.5rem\\] {
  height: 1.5rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[125px\\] {
  height: 125px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[2\\.25rem\\] {
  height: 2.25rem;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[2rem\\] {
  height: 2rem;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[3rem\\] {
  height: 3rem;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[5px\\] {
  height: 5px;
}
.h-\\[9px\\] {
  height: 9px;
}
.h-\\[calc\\(100\\%\\+18px\\)\\] {
  height: calc(100% + 18px);
}
.h-\\[calc\\(100vh-400px\\)\\] {
  height: calc(100vh - 400px);
}
.h-\\[calc\\(100vh-437px\\)\\] {
  height: calc(100vh - 437px);
}
.h-\\[calc\\(100vh-440px\\)\\] {
  height: calc(100vh - 440px);
}
.h-\\[calc\\(100vh-452px\\)\\] {
  height: calc(100vh - 452px);
}
.h-\\[calc\\(100vh-461px\\)\\] {
  height: calc(100vh - 461px);
}
.h-\\[calc\\(100vh-483px\\)\\] {
  height: calc(100vh - 483px);
}
.h-\\[calc\\(100vh-500px\\)\\] {
  height: calc(100vh - 500px);
}
.h-\\[calc\\(100vh-510px-41px\\)\\] {
  height: calc(100vh - 510px - 41px);
}
.h-\\[calc\\(100vh-520px\\)\\] {
  height: calc(100vh - 520px);
}
.h-\\[calc\\(100vh-575px\\)\\] {
  height: calc(100vh - 575px);
}
.h-\\[calc\\(100vh-72px\\)\\] {
  height: calc(100vh - 72px);
}
.h-full {
  height: 100%;
}
.\\!max-h-0 {
  max-height: 0px !important;
}
.\\!max-h-40 {
  max-height: 10rem !important;
}
.\\!max-h-full {
  max-height: 100% !important;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[228px\\] {
  max-height: 228px;
}
.max-h-\\[24rem\\] {
  max-height: 24rem;
}
.max-h-\\[34px\\] {
  max-height: 34px;
}
.max-h-\\[36px\\] {
  max-height: 36px;
}
.max-h-\\[90\\%\\] {
  max-height: 90%;
}
.max-h-\\[calc\\(100vh-385px\\)\\] {
  max-height: calc(100vh - 385px);
}
.max-h-\\[calc\\(100vh-420px\\)\\] {
  max-height: calc(100vh - 420px);
}
.max-h-\\[calc\\(100vh-426px\\)\\] {
  max-height: calc(100vh - 426px);
}
.max-h-\\[calc\\(100vh-448px\\)\\] {
  max-height: calc(100vh - 448px);
}
.max-h-\\[calc\\(100vh-542px\\)\\] {
  max-height: calc(100vh - 542px);
}
.max-h-\\[calc\\(100vh-557px\\)\\] {
  max-height: calc(100vh - 557px);
}
.max-h-\\[calc\\(100vh-72px\\)\\] {
  max-height: calc(100vh - 72px);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[125px\\] {
  min-height: 125px;
}
.min-h-\\[12rem\\] {
  min-height: 12rem;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[70px\\] {
  min-height: 70px;
}
.min-h-\\[calc\\(100vh-190px\\)\\] {
  min-height: calc(100vh - 190px);
}
.min-h-\\[calc\\(100vh-385px\\)\\] {
  min-height: calc(100vh - 385px);
}
.min-h-\\[calc\\(100vh-426px\\)\\] {
  min-height: calc(100vh - 426px);
}
.min-h-\\[calc\\(100vh-448px\\)\\] {
  min-height: calc(100vh - 448px);
}
.min-h-\\[calc\\(100vh-557px\\)\\] {
  min-height: calc(100vh - 557px);
}
.min-h-\\[calc\\(100vh-72px-2rem\\)\\] {
  min-height: calc(100vh - 72px - 2rem);
}
.min-h-\\[calc\\(100vh-72px-4rem\\)\\] {
  min-height: calc(100vh - 72px - 4rem);
}
.min-h-full {
  min-height: 100%;
}
.\\!w-screen {
  width: 100vw !important;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[0\\.3rem\\] {
  width: 0.3rem;
}
.w-\\[1\\%\\] {
  width: 1%;
}
.w-\\[1\\.143rem\\] {
  width: 1.143rem;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[12\\.5rem\\] {
  width: 12.5rem;
}
.w-\\[125px\\] {
  width: 125px;
}
.w-\\[13\\.3\\%\\] {
  width: 13.3%;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[16\\%\\] {
  width: 16%;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[255px\\] {
  width: 255px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[2rem\\] {
  width: 2rem;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[3rem\\] {
  width: 3rem;
}
.w-\\[4\\%\\] {
  width: 4%;
}
.w-\\[50vw\\] {
  width: 50vw;
}
.w-\\[5px\\] {
  width: 5px;
}
.w-\\[8\\%\\] {
  width: 8%;
}
.w-\\[8\\.57\\%\\] {
  width: 8.57%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[9px\\] {
  width: 9px;
}
.w-\\[calc\\(100\\%\\+18px\\)\\] {
  width: calc(100% + 18px);
}
.w-\\[calc\\(100\\%-1rem\\)\\] {
  width: calc(100% - 1rem);
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-\\[1\\.143rem\\] {
  min-width: 1.143rem;
}
.min-w-\\[1\\.5rem\\] {
  min-width: 1.5rem;
}
.min-w-\\[10rem\\] {
  min-width: 10rem;
}
.min-w-\\[11rem\\] {
  min-width: 11rem;
}
.min-w-\\[12\\.5rem\\] {
  min-width: 12.5rem;
}
.min-w-\\[125px\\] {
  min-width: 125px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[2\\.25rem\\] {
  min-width: 2.25rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[270px\\] {
  min-width: 270px;
}
.min-w-\\[28px\\] {
  min-width: 28px;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.min-w-\\[3rem\\] {
  min-width: 3rem;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.min-w-min {
  min-width: min-content;
}
.max-w-6 {
  max-width: 1.5rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[1864px\\] {
  max-width: 1864px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[30rem\\] {
  max-width: 30rem;
}
.max-w-\\[3rem\\] {
  max-width: 3rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-initial {
  flex: 0 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-2\\/4 {
  flex-basis: 50%;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-bottom {
  transform-origin: bottom;
}
.origin-center {
  transform-origin: center;
}
.origin-left {
  transform-origin: left;
}
.origin-right {
  transform-origin: right;
}
.origin-top {
  transform-origin: top;
}
.\\!-translate-x-full {
  --tw-translate-x: -100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!-translate-y-full {
  --tw-translate-y: -100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!translate-x-0 {
  --tw-translate-x: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!translate-x-full {
  --tw-translate-x: 100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!translate-y-full {
  --tw-translate-y: 100% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[120\\%\\] {
  --tw-translate-x: 120%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-180 {
  --tw-rotate: -180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!scale-100 {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\!scale-75 {
  --tw-scale-x: .75 !important;
  --tw-scale-y: .75 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!transform-none {
  transform: none !important;
}
.transform-none {
  transform: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.\\!cursor-not-allowed {
  cursor: not-allowed !important;
}
.cursor-auto {
  cursor: auto;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-row-resize {
  cursor: row-resize;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.grid-cols-none {
  grid-template-columns: none;
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.\\!items-center {
  align-items: center !important;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.\\!justify-center {
  justify-content: center !important;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.\\!space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0 !important;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-x-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0px * var(--tw-space-x-reverse));
  margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.125rem * var(--tw-space-x-reverse));
  margin-left: calc(0.125rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-tremor-border > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.self-auto {
  align-self: auto;
}
.self-center {
  align-self: center;
}
.self-baseline {
  align-self: baseline;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.overscroll-auto {
  overscroll-behavior: auto;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-tremor-default {
  border-radius: 4px;
}
.rounded-tremor-full {
  border-radius: 9999px;
}
.rounded-tremor-small {
  border-radius: 2px;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-b-tremor-default {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-l-tremor-default {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-l-tremor-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-tremor-small {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-r-tremor-default {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.rounded-r-tremor-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-tremor-small {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-none {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}
.rounded-t-tremor-default {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}
.rounded-br-none {
  border-bottom-right-radius: 0px;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}
.rounded-tl-none {
  border-top-left-radius: 0px;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}
.rounded-tr-none {
  border-top-right-radius: 0px;
}
.\\!border {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-x-0 {
  border-left-width: 0px;
  border-right-width: 0px;
}
.border-x-\\[0\\.25rem\\] {
  border-left-width: 0.25rem;
  border-right-width: 0.25rem;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.border-y-\\[0\\.25rem\\] {
  border-top-width: 0.25rem;
  border-bottom-width: 0.25rem;
}
.\\!border-t {
  border-top-width: 1px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-\\[0\\.25rem\\] {
  border-bottom-width: 0.25rem;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-\\[0\\.25rem\\] {
  border-left-width: 0.25rem;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-4 {
  border-right-width: 4px;
}
.border-r-\\[0\\.25rem\\] {
  border-right-width: 0.25rem;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[0\\.25rem\\] {
  border-top-width: 0.25rem;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.\\!border-solid {
  border-style: solid !important;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-none {
  border-style: none;
}
.\\!border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity)) !important;
}
.border-\\[\\#B2F2BB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(178 242 187 / var(--tw-border-opacity));
}
.border-\\[\\#B3E5FC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(179 229 252 / var(--tw-border-opacity));
}
.border-\\[\\#E0E0E0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.border-\\[\\#e20221\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
.border-\\[\\#f0f0f0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 240 240 / var(--tw-border-opacity));
}
.border-\\[\\#ffcc33\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 204 51 / var(--tw-border-opacity));
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity));
}
.border-amber-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 251 235 / var(--tw-border-opacity));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.border-amber-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity));
}
.border-amber-700 {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity));
}
.border-amber-800 {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity));
}
.border-amber-900 {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity));
}
.border-amber-950 {
  --tw-border-opacity: 1;
  border-color: rgb(69 26 3 / var(--tw-border-opacity));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.border-blue-50 {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.border-blue-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}
.border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
.border-blue-900\\/40 {
  border-color: rgb(30 58 138 / 0.4);
}
.border-blue-950 {
  --tw-border-opacity: 1;
  border-color: rgb(23 37 84 / var(--tw-border-opacity));
}
.border-cyan-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity));
}
.border-cyan-200 {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity));
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.border-cyan-400 {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity));
}
.border-cyan-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 254 255 / var(--tw-border-opacity));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}
.border-cyan-700 {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}
.border-cyan-800 {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity));
}
.border-cyan-900 {
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / var(--tw-border-opacity));
}
.border-cyan-950 {
  --tw-border-opacity: 1;
  border-color: rgb(8 51 68 / var(--tw-border-opacity));
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.border-emerald-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
.border-emerald-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
.border-emerald-800 {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity));
}
.border-emerald-900 {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity));
}
.border-emerald-950 {
  --tw-border-opacity: 1;
  border-color: rgb(2 44 34 / var(--tw-border-opacity));
}
.border-fuchsia-100 {
  --tw-border-opacity: 1;
  border-color: rgb(250 232 255 / var(--tw-border-opacity));
}
.border-fuchsia-200 {
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity));
}
.border-fuchsia-300 {
  --tw-border-opacity: 1;
  border-color: rgb(240 171 252 / var(--tw-border-opacity));
}
.border-fuchsia-400 {
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / var(--tw-border-opacity));
}
.border-fuchsia-50 {
  --tw-border-opacity: 1;
  border-color: rgb(253 244 255 / var(--tw-border-opacity));
}
.border-fuchsia-500 {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
.border-fuchsia-600 {
  --tw-border-opacity: 1;
  border-color: rgb(192 38 211 / var(--tw-border-opacity));
}
.border-fuchsia-700 {
  --tw-border-opacity: 1;
  border-color: rgb(162 28 175 / var(--tw-border-opacity));
}
.border-fuchsia-800 {
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / var(--tw-border-opacity));
}
.border-fuchsia-900 {
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / var(--tw-border-opacity));
}
.border-fuchsia-950 {
  --tw-border-opacity: 1;
  border-color: rgb(74 4 78 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.border-gray-950 {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.border-green-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 244 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
.border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.border-green-800 {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity));
}
.border-green-900 {
  --tw-border-opacity: 1;
  border-color: rgb(20 83 45 / var(--tw-border-opacity));
}
.border-green-950 {
  --tw-border-opacity: 1;
  border-color: rgb(5 46 22 / var(--tw-border-opacity));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
}
.border-indigo-50 {
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
.border-indigo-700 {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity));
}
.border-indigo-800 {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity));
}
.border-indigo-900 {
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity));
}
.border-indigo-950 {
  --tw-border-opacity: 1;
  border-color: rgb(30 27 75 / var(--tw-border-opacity));
}
.border-inherit {
  border-color: inherit;
}
.border-lime-100 {
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / var(--tw-border-opacity));
}
.border-lime-200 {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity));
}
.border-lime-300 {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity));
}
.border-lime-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity));
}
.border-lime-50 {
  --tw-border-opacity: 1;
  border-color: rgb(247 254 231 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
.border-lime-600 {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity));
}
.border-lime-700 {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity));
}
.border-lime-800 {
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / var(--tw-border-opacity));
}
.border-lime-900 {
  --tw-border-opacity: 1;
  border-color: rgb(54 83 20 / var(--tw-border-opacity));
}
.border-lime-950 {
  --tw-border-opacity: 1;
  border-color: rgb(26 46 5 / var(--tw-border-opacity));
}
.border-neutral-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity));
}
.border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
.border-neutral-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 163 163 / var(--tw-border-opacity));
}
.border-neutral-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.border-neutral-500 {
  --tw-border-opacity: 1;
  border-color: rgb(115 115 115 / var(--tw-border-opacity));
}
.border-neutral-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity));
}
.border-neutral-700 {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}
.border-neutral-800 {
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / var(--tw-border-opacity));
}
.border-neutral-900 {
  --tw-border-opacity: 1;
  border-color: rgb(23 23 23 / var(--tw-border-opacity));
}
.border-neutral-950 {
  --tw-border-opacity: 1;
  border-color: rgb(10 10 10 / var(--tw-border-opacity));
}
.border-orange-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
.border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
.border-orange-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
.border-orange-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 247 237 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity));
}
.border-orange-700 {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity));
}
.border-orange-800 {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity));
}
.border-orange-900 {
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / var(--tw-border-opacity));
}
.border-orange-950 {
  --tw-border-opacity: 1;
  border-color: rgb(67 20 7 / var(--tw-border-opacity));
}
.border-pink-100 {
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity));
}
.border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity));
}
.border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity));
}
.border-pink-400 {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity));
}
.border-pink-50 {
  --tw-border-opacity: 1;
  border-color: rgb(253 242 248 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.border-pink-600 {
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity));
}
.border-pink-700 {
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity));
}
.border-pink-800 {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity));
}
.border-pink-900 {
  --tw-border-opacity: 1;
  border-color: rgb(131 24 67 / var(--tw-border-opacity));
}
.border-pink-950 {
  --tw-border-opacity: 1;
  border-color: rgb(80 7 36 / var(--tw-border-opacity));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
.border-purple-300 {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity));
}
.border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity));
}
.border-purple-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 245 255 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}
.border-purple-600 {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity));
}
.border-purple-700 {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity));
}
.border-purple-800 {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity));
}
.border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(88 28 135 / var(--tw-border-opacity));
}
.border-purple-950 {
  --tw-border-opacity: 1;
  border-color: rgb(59 7 100 / var(--tw-border-opacity));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.border-red-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.border-red-800 {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity));
}
.border-red-900 {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity));
}
.border-red-950 {
  --tw-border-opacity: 1;
  border-color: rgb(69 10 10 / var(--tw-border-opacity));
}
.border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity));
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
.border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
.border-rose-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity));
}
.border-rose-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 241 242 / var(--tw-border-opacity));
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.border-rose-600 {
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity));
}
.border-rose-700 {
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity));
}
.border-rose-800 {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity));
}
.border-rose-900 {
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / var(--tw-border-opacity));
}
.border-rose-950 {
  --tw-border-opacity: 1;
  border-color: rgb(76 5 25 / var(--tw-border-opacity));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(0 75 141 / var(--tw-border-opacity));
}
.border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity));
}
.border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity));
}
.border-sky-300 {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
.border-sky-400 {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity));
}
.border-sky-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / var(--tw-border-opacity));
}
.border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.border-sky-600 {
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity));
}
.border-sky-700 {
  --tw-border-opacity: 1;
  border-color: rgb(3 105 161 / var(--tw-border-opacity));
}
.border-sky-800 {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity));
}
.border-sky-900 {
  --tw-border-opacity: 1;
  border-color: rgb(12 74 110 / var(--tw-border-opacity));
}
.border-sky-950 {
  --tw-border-opacity: 1;
  border-color: rgb(8 47 73 / var(--tw-border-opacity));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity));
}
.border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity));
}
.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity));
}
.border-slate-900 {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}
.border-slate-950 {
  --tw-border-opacity: 1;
  border-color: rgb(2 6 23 / var(--tw-border-opacity));
}
.border-stone-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-border-opacity));
}
.border-stone-200 {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity));
}
.border-stone-300 {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
.border-stone-400 {
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity));
}
.border-stone-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / var(--tw-border-opacity));
}
.border-stone-500 {
  --tw-border-opacity: 1;
  border-color: rgb(120 113 108 / var(--tw-border-opacity));
}
.border-stone-600 {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity));
}
.border-stone-700 {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity));
}
.border-stone-800 {
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / var(--tw-border-opacity));
}
.border-stone-900 {
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / var(--tw-border-opacity));
}
.border-stone-950 {
  --tw-border-opacity: 1;
  border-color: rgb(12 10 9 / var(--tw-border-opacity));
}
.border-teal-100 {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity));
}
.border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
.border-teal-400 {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity));
}
.border-teal-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 250 / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
.border-teal-600 {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity));
}
.border-teal-700 {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity));
}
.border-teal-800 {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity));
}
.border-teal-900 {
  --tw-border-opacity: 1;
  border-color: rgb(19 78 74 / var(--tw-border-opacity));
}
.border-teal-950 {
  --tw-border-opacity: 1;
  border-color: rgb(4 47 46 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-tremor-background {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-tremor-border {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-tremor-brand {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-tremor-brand-emphasis {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.border-tremor-brand-inverted {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-tremor-brand-subtle {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.border-violet-100 {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity));
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
.border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
.border-violet-400 {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity));
}
.border-violet-50 {
  --tw-border-opacity: 1;
  border-color: rgb(245 243 255 / var(--tw-border-opacity));
}
.border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.border-violet-600 {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity));
}
.border-violet-700 {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity));
}
.border-violet-800 {
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity));
}
.border-violet-900 {
  --tw-border-opacity: 1;
  border-color: rgb(76 29 149 / var(--tw-border-opacity));
}
.border-violet-950 {
  --tw-border-opacity: 1;
  border-color: rgb(46 16 101 / var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-yellow-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity));
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}
.border-yellow-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 252 232 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
.border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
}
.border-yellow-700 {
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / var(--tw-border-opacity));
}
.border-yellow-800 {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity));
}
.border-yellow-900 {
  --tw-border-opacity: 1;
  border-color: rgb(113 63 18 / var(--tw-border-opacity));
}
.border-yellow-950 {
  --tw-border-opacity: 1;
  border-color: rgb(66 32 6 / var(--tw-border-opacity));
}
.border-zinc-100 {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity));
}
.border-zinc-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}
.border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.border-zinc-400 {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity));
}
.border-zinc-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.border-zinc-500 {
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity));
}
.border-zinc-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity));
}
.border-zinc-700 {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.border-zinc-900 {
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity));
}
.border-zinc-950 {
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity));
}
.border-b-gray-600 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-l-gray-600 {
  --tw-border-opacity: 1;
  border-left-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-r-gray-600 {
  --tw-border-opacity: 1;
  border-right-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-t-gray-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#f1f5f9\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity)) !important;
}
.\\!bg-blue-500 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity)) !important;
}
.\\!bg-gray-700 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity)) !important;
}
.\\!bg-rose-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity)) !important;
}
.\\!bg-secondary {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 75 141 / var(--tw-bg-opacity)) !important;
}
.\\!bg-sky-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity)) !important;
}
.bg-\\[\\#B2F2BB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(178 242 187 / var(--tw-bg-opacity));
}
.bg-\\[\\#B3E5FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(179 229 252 / var(--tw-bg-opacity));
}
.bg-\\[\\#E0E0E0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-\\[\\#e20221\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
.bg-\\[\\#e2e8f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffcc33\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 51 / var(--tw-bg-opacity));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
.bg-amber-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
.bg-amber-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}
.bg-amber-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity));
}
.bg-amber-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity));
}
.bg-amber-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
.bg-blue-300\\/20 {
  background-color: rgb(147 197 253 / 0.2);
}
.bg-blue-300\\/40 {
  background-color: rgb(147 197 253 / 0.4);
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-blue-50\\/50 {
  background-color: rgb(239 246 255 / 0.5);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-500\\/20 {
  background-color: rgb(59 130 246 / 0.2);
}
.bg-blue-500\\/40 {
  background-color: rgb(59 130 246 / 0.4);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}
.bg-blue-900\\/40 {
  background-color: rgb(30 58 138 / 0.4);
}
.bg-blue-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity));
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
.bg-cyan-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}
.bg-cyan-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity));
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
.bg-cyan-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}
.bg-cyan-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}
.bg-cyan-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}
.bg-cyan-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 51 68 / var(--tw-bg-opacity));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-emerald-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
.bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.bg-emerald-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity));
}
.bg-emerald-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}
.bg-emerald-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity));
}
.bg-fuchsia-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity));
}
.bg-fuchsia-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / var(--tw-bg-opacity));
}
.bg-fuchsia-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / var(--tw-bg-opacity));
}
.bg-fuchsia-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity));
}
.bg-fuchsia-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity));
}
.bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity));
}
.bg-fuchsia-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity));
}
.bg-fuchsia-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / var(--tw-bg-opacity));
}
.bg-fuchsia-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / var(--tw-bg-opacity));
}
.bg-fuchsia-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / var(--tw-bg-opacity));
}
.bg-fuchsia-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 4 78 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-100\\/40 {
  background-color: rgb(243 244 246 / 0.4);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-300\\/20 {
  background-color: rgb(209 213 219 / 0.2);
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-gray-800\\/80 {
  background-color: rgb(31 41 55 / 0.8);
}
.bg-gray-800\\/90 {
  background-color: rgb(31 41 55 / 0.9);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.bg-gray-950\\/40 {
  background-color: rgb(3 7 18 / 0.4);
}
.bg-gray-light {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}
.bg-green-300\\/20 {
  background-color: rgb(134 239 172 / 0.2);
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.bg-green-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity));
}
.bg-green-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
.bg-green-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}
.bg-indigo-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity));
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}
.bg-indigo-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity));
}
.bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity));
}
.bg-indigo-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity));
}
.bg-inherit {
  background-color: inherit;
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
.bg-lime-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}
.bg-lime-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity));
}
.bg-lime-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.bg-lime-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
.bg-lime-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity));
}
.bg-lime-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / var(--tw-bg-opacity));
}
.bg-lime-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / var(--tw-bg-opacity));
}
.bg-lime-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 46 5 / var(--tw-bg-opacity));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity));
}
.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
.bg-neutral-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity));
}
.bg-neutral-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-neutral-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}
.bg-neutral-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
.bg-neutral-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
.bg-neutral-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}
.bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}
.bg-neutral-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
.bg-orange-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
.bg-orange-300\\/20 {
  background-color: rgb(253 186 116 / 0.2);
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
.bg-orange-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity));
}
.bg-orange-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / var(--tw-bg-opacity));
}
.bg-orange-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / var(--tw-bg-opacity));
}
.bg-orange-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 20 7 / var(--tw-bg-opacity));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
.bg-pink-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity));
}
.bg-pink-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity));
}
.bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity));
}
.bg-pink-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity));
}
.bg-pink-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / var(--tw-bg-opacity));
}
.bg-pink-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / var(--tw-bg-opacity));
}
.bg-pink-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(80 7 36 / var(--tw-bg-opacity));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}
.bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
.bg-purple-300\\/20 {
  background-color: rgb(216 180 254 / 0.2);
}
.bg-purple-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
.bg-purple-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity));
}
.bg-purple-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity));
}
.bg-purple-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
.bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}
.bg-red-300\\/20 {
  background-color: rgb(252 165 165 / 0.2);
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.bg-red-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.bg-red-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity));
}
.bg-red-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
.bg-rose-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}
.bg-rose-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / var(--tw-bg-opacity));
}
.bg-rose-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
.bg-rose-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity));
}
.bg-rose-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity));
}
.bg-rose-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / var(--tw-bg-opacity));
}
.bg-rose-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 5 25 / var(--tw-bg-opacity));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(0 75 141 / var(--tw-bg-opacity));
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
.bg-sky-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.bg-sky-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity));
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity));
}
.bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.bg-sky-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
.bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
.bg-sky-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity));
}
.bg-sky-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / var(--tw-bg-opacity));
}
.bg-sky-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.bg-slate-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity));
}
.bg-slate-950\\/30 {
  background-color: rgb(2 6 23 / 0.3);
}
.bg-stone-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity));
}
.bg-stone-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity));
}
.bg-stone-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / var(--tw-bg-opacity));
}
.bg-stone-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity));
}
.bg-stone-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity));
}
.bg-stone-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity));
}
.bg-stone-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity));
}
.bg-stone-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity));
}
.bg-stone-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity));
}
.bg-stone-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity));
}
.bg-stone-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
.bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
.bg-teal-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity));
}
.bg-teal-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity));
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
.bg-teal-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity));
}
.bg-teal-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity));
}
.bg-teal-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / var(--tw-bg-opacity));
}
.bg-teal-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 47 46 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-tremor-background {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-tremor-background-emphasis {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-tremor-background-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-tremor-background-subtle {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-tremor-border {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-tremor-brand {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-tremor-brand-faint {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.bg-tremor-brand-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-tremor-brand-muted\\/50 {
  background-color: rgb(191 219 254 / 0.5);
}
.bg-tremor-brand-subtle {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.bg-tremor-content-subtle {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
.bg-violet-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity));
}
.bg-violet-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity));
}
.bg-violet-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity));
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity));
}
.bg-violet-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity));
}
.bg-violet-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / var(--tw-bg-opacity));
}
.bg-violet-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / var(--tw-bg-opacity));
}
.bg-violet-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
.bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.bg-yellow-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
.bg-yellow-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / var(--tw-bg-opacity));
}
.bg-yellow-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}
.bg-yellow-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(66 32 6 / var(--tw-bg-opacity));
}
.bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.bg-zinc-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
.bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.bg-zinc-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity));
}
.bg-zinc-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-zinc-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.bg-zinc-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity));
}
.bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.bg-zinc-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity));
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-90 {
  --tw-bg-opacity: 0.9;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-tremor-background {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-tremor-background {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-clip-padding {
  background-clip: padding-box;
}
.fill-\\[\\#e20221\\] {
  fill: #e20221;
}
.fill-\\[\\#ffcc33\\] {
  fill: #ffcc33;
}
.fill-amber-100 {
  fill: #fef3c7;
}
.fill-amber-200 {
  fill: #fde68a;
}
.fill-amber-300 {
  fill: #fcd34d;
}
.fill-amber-400 {
  fill: #fbbf24;
}
.fill-amber-50 {
  fill: #fffbeb;
}
.fill-amber-500 {
  fill: #f59e0b;
}
.fill-amber-600 {
  fill: #d97706;
}
.fill-amber-700 {
  fill: #b45309;
}
.fill-amber-800 {
  fill: #92400e;
}
.fill-amber-900 {
  fill: #78350f;
}
.fill-amber-950 {
  fill: #451a03;
}
.fill-blue-100 {
  fill: #dbeafe;
}
.fill-blue-200 {
  fill: #bfdbfe;
}
.fill-blue-300 {
  fill: #93c5fd;
}
.fill-blue-400 {
  fill: #60a5fa;
}
.fill-blue-50 {
  fill: #eff6ff;
}
.fill-blue-500 {
  fill: #3b82f6;
}
.fill-blue-600 {
  fill: #2563eb;
}
.fill-blue-700 {
  fill: #1d4ed8;
}
.fill-blue-800 {
  fill: #1e40af;
}
.fill-blue-900 {
  fill: #1e3a8a;
}
.fill-blue-950 {
  fill: #172554;
}
.fill-cyan-100 {
  fill: #cffafe;
}
.fill-cyan-200 {
  fill: #a5f3fc;
}
.fill-cyan-300 {
  fill: #67e8f9;
}
.fill-cyan-400 {
  fill: #22d3ee;
}
.fill-cyan-50 {
  fill: #ecfeff;
}
.fill-cyan-500 {
  fill: #06b6d4;
}
.fill-cyan-600 {
  fill: #0891b2;
}
.fill-cyan-700 {
  fill: #0e7490;
}
.fill-cyan-800 {
  fill: #155e75;
}
.fill-cyan-900 {
  fill: #164e63;
}
.fill-cyan-950 {
  fill: #083344;
}
.fill-emerald-100 {
  fill: #d1fae5;
}
.fill-emerald-200 {
  fill: #a7f3d0;
}
.fill-emerald-300 {
  fill: #6ee7b7;
}
.fill-emerald-400 {
  fill: #34d399;
}
.fill-emerald-50 {
  fill: #ecfdf5;
}
.fill-emerald-500 {
  fill: #10b981;
}
.fill-emerald-600 {
  fill: #059669;
}
.fill-emerald-700 {
  fill: #047857;
}
.fill-emerald-800 {
  fill: #065f46;
}
.fill-emerald-900 {
  fill: #064e3b;
}
.fill-emerald-950 {
  fill: #022c22;
}
.fill-fuchsia-100 {
  fill: #fae8ff;
}
.fill-fuchsia-200 {
  fill: #f5d0fe;
}
.fill-fuchsia-300 {
  fill: #f0abfc;
}
.fill-fuchsia-400 {
  fill: #e879f9;
}
.fill-fuchsia-50 {
  fill: #fdf4ff;
}
.fill-fuchsia-500 {
  fill: #d946ef;
}
.fill-fuchsia-600 {
  fill: #c026d3;
}
.fill-fuchsia-700 {
  fill: #a21caf;
}
.fill-fuchsia-800 {
  fill: #86198f;
}
.fill-fuchsia-900 {
  fill: #701a75;
}
.fill-fuchsia-950 {
  fill: #4a044e;
}
.fill-gray-100 {
  fill: #f3f4f6;
}
.fill-gray-200 {
  fill: #e5e7eb;
}
.fill-gray-300 {
  fill: #d1d5db;
}
.fill-gray-400 {
  fill: #9ca3af;
}
.fill-gray-50 {
  fill: #f9fafb;
}
.fill-gray-500 {
  fill: #6b7280;
}
.fill-gray-600 {
  fill: #4b5563;
}
.fill-gray-700 {
  fill: #374151;
}
.fill-gray-800 {
  fill: #1f2937;
}
.fill-gray-900 {
  fill: #111827;
}
.fill-gray-950 {
  fill: #030712;
}
.fill-green-100 {
  fill: #dcfce7;
}
.fill-green-200 {
  fill: #bbf7d0;
}
.fill-green-300 {
  fill: #86efac;
}
.fill-green-400 {
  fill: #4ade80;
}
.fill-green-50 {
  fill: #f0fdf4;
}
.fill-green-500 {
  fill: #22c55e;
}
.fill-green-600 {
  fill: #16a34a;
}
.fill-green-700 {
  fill: #15803d;
}
.fill-green-800 {
  fill: #166534;
}
.fill-green-900 {
  fill: #14532d;
}
.fill-green-950 {
  fill: #052e16;
}
.fill-indigo-100 {
  fill: #e0e7ff;
}
.fill-indigo-200 {
  fill: #c7d2fe;
}
.fill-indigo-300 {
  fill: #a5b4fc;
}
.fill-indigo-400 {
  fill: #818cf8;
}
.fill-indigo-50 {
  fill: #eef2ff;
}
.fill-indigo-500 {
  fill: #6366f1;
}
.fill-indigo-600 {
  fill: #4f46e5;
}
.fill-indigo-700 {
  fill: #4338ca;
}
.fill-indigo-800 {
  fill: #3730a3;
}
.fill-indigo-900 {
  fill: #312e81;
}
.fill-indigo-950 {
  fill: #1e1b4b;
}
.fill-lime-100 {
  fill: #ecfccb;
}
.fill-lime-200 {
  fill: #d9f99d;
}
.fill-lime-300 {
  fill: #bef264;
}
.fill-lime-400 {
  fill: #a3e635;
}
.fill-lime-50 {
  fill: #f7fee7;
}
.fill-lime-500 {
  fill: #84cc16;
}
.fill-lime-600 {
  fill: #65a30d;
}
.fill-lime-700 {
  fill: #4d7c0f;
}
.fill-lime-800 {
  fill: #3f6212;
}
.fill-lime-900 {
  fill: #365314;
}
.fill-lime-950 {
  fill: #1a2e05;
}
.fill-neutral-100 {
  fill: #f5f5f5;
}
.fill-neutral-200 {
  fill: #e5e5e5;
}
.fill-neutral-300 {
  fill: #d4d4d4;
}
.fill-neutral-400 {
  fill: #a3a3a3;
}
.fill-neutral-50 {
  fill: #fafafa;
}
.fill-neutral-500 {
  fill: #737373;
}
.fill-neutral-600 {
  fill: #525252;
}
.fill-neutral-700 {
  fill: #404040;
}
.fill-neutral-800 {
  fill: #262626;
}
.fill-neutral-900 {
  fill: #171717;
}
.fill-neutral-950 {
  fill: #0a0a0a;
}
.fill-none {
  fill: none;
}
.fill-orange-100 {
  fill: #ffedd5;
}
.fill-orange-200 {
  fill: #fed7aa;
}
.fill-orange-300 {
  fill: #fdba74;
}
.fill-orange-400 {
  fill: #fb923c;
}
.fill-orange-50 {
  fill: #fff7ed;
}
.fill-orange-500 {
  fill: #f97316;
}
.fill-orange-600 {
  fill: #ea580c;
}
.fill-orange-700 {
  fill: #c2410c;
}
.fill-orange-800 {
  fill: #9a3412;
}
.fill-orange-900 {
  fill: #7c2d12;
}
.fill-orange-950 {
  fill: #431407;
}
.fill-pink-100 {
  fill: #fce7f3;
}
.fill-pink-200 {
  fill: #fbcfe8;
}
.fill-pink-300 {
  fill: #f9a8d4;
}
.fill-pink-400 {
  fill: #f472b6;
}
.fill-pink-50 {
  fill: #fdf2f8;
}
.fill-pink-500 {
  fill: #ec4899;
}
.fill-pink-600 {
  fill: #db2777;
}
.fill-pink-700 {
  fill: #be185d;
}
.fill-pink-800 {
  fill: #9d174d;
}
.fill-pink-900 {
  fill: #831843;
}
.fill-pink-950 {
  fill: #500724;
}
.fill-purple-100 {
  fill: #f3e8ff;
}
.fill-purple-200 {
  fill: #e9d5ff;
}
.fill-purple-300 {
  fill: #d8b4fe;
}
.fill-purple-400 {
  fill: #c084fc;
}
.fill-purple-50 {
  fill: #faf5ff;
}
.fill-purple-500 {
  fill: #a855f7;
}
.fill-purple-600 {
  fill: #9333ea;
}
.fill-purple-700 {
  fill: #7e22ce;
}
.fill-purple-800 {
  fill: #6b21a8;
}
.fill-purple-900 {
  fill: #581c87;
}
.fill-purple-950 {
  fill: #3b0764;
}
.fill-red-100 {
  fill: #fee2e2;
}
.fill-red-200 {
  fill: #fecaca;
}
.fill-red-300 {
  fill: #fca5a5;
}
.fill-red-400 {
  fill: #f87171;
}
.fill-red-50 {
  fill: #fef2f2;
}
.fill-red-500 {
  fill: #ef4444;
}
.fill-red-600 {
  fill: #dc2626;
}
.fill-red-700 {
  fill: #b91c1c;
}
.fill-red-800 {
  fill: #991b1b;
}
.fill-red-900 {
  fill: #7f1d1d;
}
.fill-red-950 {
  fill: #450a0a;
}
.fill-rose-100 {
  fill: #ffe4e6;
}
.fill-rose-200 {
  fill: #fecdd3;
}
.fill-rose-300 {
  fill: #fda4af;
}
.fill-rose-400 {
  fill: #fb7185;
}
.fill-rose-50 {
  fill: #fff1f2;
}
.fill-rose-500 {
  fill: #f43f5e;
}
.fill-rose-600 {
  fill: #e11d48;
}
.fill-rose-700 {
  fill: #be123c;
}
.fill-rose-800 {
  fill: #9f1239;
}
.fill-rose-900 {
  fill: #881337;
}
.fill-rose-950 {
  fill: #4c0519;
}
.fill-sky-100 {
  fill: #e0f2fe;
}
.fill-sky-200 {
  fill: #bae6fd;
}
.fill-sky-300 {
  fill: #7dd3fc;
}
.fill-sky-400 {
  fill: #38bdf8;
}
.fill-sky-50 {
  fill: #f0f9ff;
}
.fill-sky-500 {
  fill: #0ea5e9;
}
.fill-sky-600 {
  fill: #0284c7;
}
.fill-sky-700 {
  fill: #0369a1;
}
.fill-sky-800 {
  fill: #075985;
}
.fill-sky-900 {
  fill: #0c4a6e;
}
.fill-sky-950 {
  fill: #082f49;
}
.fill-slate-100 {
  fill: #f1f5f9;
}
.fill-slate-200 {
  fill: #e2e8f0;
}
.fill-slate-300 {
  fill: #cbd5e1;
}
.fill-slate-400 {
  fill: #94a3b8;
}
.fill-slate-50 {
  fill: #f8fafc;
}
.fill-slate-500 {
  fill: #64748b;
}
.fill-slate-600 {
  fill: #475569;
}
.fill-slate-700 {
  fill: #334155;
}
.fill-slate-800 {
  fill: #1e293b;
}
.fill-slate-900 {
  fill: #0f172a;
}
.fill-slate-950 {
  fill: #020617;
}
.fill-stone-100 {
  fill: #f5f5f4;
}
.fill-stone-200 {
  fill: #e7e5e4;
}
.fill-stone-300 {
  fill: #d6d3d1;
}
.fill-stone-400 {
  fill: #a8a29e;
}
.fill-stone-50 {
  fill: #fafaf9;
}
.fill-stone-500 {
  fill: #78716c;
}
.fill-stone-600 {
  fill: #57534e;
}
.fill-stone-700 {
  fill: #44403c;
}
.fill-stone-800 {
  fill: #292524;
}
.fill-stone-900 {
  fill: #1c1917;
}
.fill-stone-950 {
  fill: #0c0a09;
}
.fill-teal-100 {
  fill: #ccfbf1;
}
.fill-teal-200 {
  fill: #99f6e4;
}
.fill-teal-300 {
  fill: #5eead4;
}
.fill-teal-400 {
  fill: #2dd4bf;
}
.fill-teal-50 {
  fill: #f0fdfa;
}
.fill-teal-500 {
  fill: #14b8a6;
}
.fill-teal-600 {
  fill: #0d9488;
}
.fill-teal-700 {
  fill: #0f766e;
}
.fill-teal-800 {
  fill: #115e59;
}
.fill-teal-900 {
  fill: #134e4a;
}
.fill-teal-950 {
  fill: #042f2e;
}
.fill-tremor-content {
  fill: #6b7280;
}
.fill-tremor-content-emphasis {
  fill: #374151;
}
.fill-violet-100 {
  fill: #ede9fe;
}
.fill-violet-200 {
  fill: #ddd6fe;
}
.fill-violet-300 {
  fill: #c4b5fd;
}
.fill-violet-400 {
  fill: #a78bfa;
}
.fill-violet-50 {
  fill: #f5f3ff;
}
.fill-violet-500 {
  fill: #8b5cf6;
}
.fill-violet-600 {
  fill: #7c3aed;
}
.fill-violet-700 {
  fill: #6d28d9;
}
.fill-violet-800 {
  fill: #5b21b6;
}
.fill-violet-900 {
  fill: #4c1d95;
}
.fill-violet-950 {
  fill: #2e1065;
}
.fill-yellow-100 {
  fill: #fef9c3;
}
.fill-yellow-200 {
  fill: #fef08a;
}
.fill-yellow-300 {
  fill: #fde047;
}
.fill-yellow-400 {
  fill: #facc15;
}
.fill-yellow-50 {
  fill: #fefce8;
}
.fill-yellow-500 {
  fill: #eab308;
}
.fill-yellow-600 {
  fill: #ca8a04;
}
.fill-yellow-700 {
  fill: #a16207;
}
.fill-yellow-800 {
  fill: #854d0e;
}
.fill-yellow-900 {
  fill: #713f12;
}
.fill-yellow-950 {
  fill: #422006;
}
.fill-zinc-100 {
  fill: #f4f4f5;
}
.fill-zinc-200 {
  fill: #e4e4e7;
}
.fill-zinc-300 {
  fill: #d4d4d8;
}
.fill-zinc-400 {
  fill: #a1a1aa;
}
.fill-zinc-50 {
  fill: #fafafa;
}
.fill-zinc-500 {
  fill: #71717a;
}
.fill-zinc-600 {
  fill: #52525b;
}
.fill-zinc-700 {
  fill: #3f3f46;
}
.fill-zinc-800 {
  fill: #27272a;
}
.fill-zinc-900 {
  fill: #18181b;
}
.fill-zinc-950 {
  fill: #09090b;
}
.stroke-\\[\\#e20221\\] {
  stroke: #e20221;
}
.stroke-\\[\\#ffcc33\\] {
  stroke: #ffcc33;
}
.stroke-amber-100 {
  stroke: #fef3c7;
}
.stroke-amber-200 {
  stroke: #fde68a;
}
.stroke-amber-300 {
  stroke: #fcd34d;
}
.stroke-amber-400 {
  stroke: #fbbf24;
}
.stroke-amber-50 {
  stroke: #fffbeb;
}
.stroke-amber-500 {
  stroke: #f59e0b;
}
.stroke-amber-600 {
  stroke: #d97706;
}
.stroke-amber-700 {
  stroke: #b45309;
}
.stroke-amber-800 {
  stroke: #92400e;
}
.stroke-amber-900 {
  stroke: #78350f;
}
.stroke-amber-950 {
  stroke: #451a03;
}
.stroke-blue-100 {
  stroke: #dbeafe;
}
.stroke-blue-200 {
  stroke: #bfdbfe;
}
.stroke-blue-300 {
  stroke: #93c5fd;
}
.stroke-blue-400 {
  stroke: #60a5fa;
}
.stroke-blue-50 {
  stroke: #eff6ff;
}
.stroke-blue-500 {
  stroke: #3b82f6;
}
.stroke-blue-600 {
  stroke: #2563eb;
}
.stroke-blue-700 {
  stroke: #1d4ed8;
}
.stroke-blue-800 {
  stroke: #1e40af;
}
.stroke-blue-900 {
  stroke: #1e3a8a;
}
.stroke-blue-950 {
  stroke: #172554;
}
.stroke-current {
  stroke: currentColor;
}
.stroke-cyan-100 {
  stroke: #cffafe;
}
.stroke-cyan-200 {
  stroke: #a5f3fc;
}
.stroke-cyan-300 {
  stroke: #67e8f9;
}
.stroke-cyan-400 {
  stroke: #22d3ee;
}
.stroke-cyan-50 {
  stroke: #ecfeff;
}
.stroke-cyan-500 {
  stroke: #06b6d4;
}
.stroke-cyan-600 {
  stroke: #0891b2;
}
.stroke-cyan-700 {
  stroke: #0e7490;
}
.stroke-cyan-800 {
  stroke: #155e75;
}
.stroke-cyan-900 {
  stroke: #164e63;
}
.stroke-cyan-950 {
  stroke: #083344;
}
.stroke-emerald-100 {
  stroke: #d1fae5;
}
.stroke-emerald-200 {
  stroke: #a7f3d0;
}
.stroke-emerald-300 {
  stroke: #6ee7b7;
}
.stroke-emerald-400 {
  stroke: #34d399;
}
.stroke-emerald-50 {
  stroke: #ecfdf5;
}
.stroke-emerald-500 {
  stroke: #10b981;
}
.stroke-emerald-600 {
  stroke: #059669;
}
.stroke-emerald-700 {
  stroke: #047857;
}
.stroke-emerald-800 {
  stroke: #065f46;
}
.stroke-emerald-900 {
  stroke: #064e3b;
}
.stroke-emerald-950 {
  stroke: #022c22;
}
.stroke-fuchsia-100 {
  stroke: #fae8ff;
}
.stroke-fuchsia-200 {
  stroke: #f5d0fe;
}
.stroke-fuchsia-300 {
  stroke: #f0abfc;
}
.stroke-fuchsia-400 {
  stroke: #e879f9;
}
.stroke-fuchsia-50 {
  stroke: #fdf4ff;
}
.stroke-fuchsia-500 {
  stroke: #d946ef;
}
.stroke-fuchsia-600 {
  stroke: #c026d3;
}
.stroke-fuchsia-700 {
  stroke: #a21caf;
}
.stroke-fuchsia-800 {
  stroke: #86198f;
}
.stroke-fuchsia-900 {
  stroke: #701a75;
}
.stroke-fuchsia-950 {
  stroke: #4a044e;
}
.stroke-gray-100 {
  stroke: #f3f4f6;
}
.stroke-gray-200 {
  stroke: #e5e7eb;
}
.stroke-gray-300 {
  stroke: #d1d5db;
}
.stroke-gray-400 {
  stroke: #9ca3af;
}
.stroke-gray-50 {
  stroke: #f9fafb;
}
.stroke-gray-500 {
  stroke: #6b7280;
}
.stroke-gray-600 {
  stroke: #4b5563;
}
.stroke-gray-700 {
  stroke: #374151;
}
.stroke-gray-800 {
  stroke: #1f2937;
}
.stroke-gray-900 {
  stroke: #111827;
}
.stroke-gray-950 {
  stroke: #030712;
}
.stroke-green-100 {
  stroke: #dcfce7;
}
.stroke-green-200 {
  stroke: #bbf7d0;
}
.stroke-green-300 {
  stroke: #86efac;
}
.stroke-green-400 {
  stroke: #4ade80;
}
.stroke-green-50 {
  stroke: #f0fdf4;
}
.stroke-green-500 {
  stroke: #22c55e;
}
.stroke-green-600 {
  stroke: #16a34a;
}
.stroke-green-700 {
  stroke: #15803d;
}
.stroke-green-800 {
  stroke: #166534;
}
.stroke-green-900 {
  stroke: #14532d;
}
.stroke-green-950 {
  stroke: #052e16;
}
.stroke-indigo-100 {
  stroke: #e0e7ff;
}
.stroke-indigo-200 {
  stroke: #c7d2fe;
}
.stroke-indigo-300 {
  stroke: #a5b4fc;
}
.stroke-indigo-400 {
  stroke: #818cf8;
}
.stroke-indigo-50 {
  stroke: #eef2ff;
}
.stroke-indigo-500 {
  stroke: #6366f1;
}
.stroke-indigo-600 {
  stroke: #4f46e5;
}
.stroke-indigo-700 {
  stroke: #4338ca;
}
.stroke-indigo-800 {
  stroke: #3730a3;
}
.stroke-indigo-900 {
  stroke: #312e81;
}
.stroke-indigo-950 {
  stroke: #1e1b4b;
}
.stroke-lime-100 {
  stroke: #ecfccb;
}
.stroke-lime-200 {
  stroke: #d9f99d;
}
.stroke-lime-300 {
  stroke: #bef264;
}
.stroke-lime-400 {
  stroke: #a3e635;
}
.stroke-lime-50 {
  stroke: #f7fee7;
}
.stroke-lime-500 {
  stroke: #84cc16;
}
.stroke-lime-600 {
  stroke: #65a30d;
}
.stroke-lime-700 {
  stroke: #4d7c0f;
}
.stroke-lime-800 {
  stroke: #3f6212;
}
.stroke-lime-900 {
  stroke: #365314;
}
.stroke-lime-950 {
  stroke: #1a2e05;
}
.stroke-neutral-100 {
  stroke: #f5f5f5;
}
.stroke-neutral-200 {
  stroke: #e5e5e5;
}
.stroke-neutral-300 {
  stroke: #d4d4d4;
}
.stroke-neutral-400 {
  stroke: #a3a3a3;
}
.stroke-neutral-50 {
  stroke: #fafafa;
}
.stroke-neutral-500 {
  stroke: #737373;
}
.stroke-neutral-600 {
  stroke: #525252;
}
.stroke-neutral-700 {
  stroke: #404040;
}
.stroke-neutral-800 {
  stroke: #262626;
}
.stroke-neutral-900 {
  stroke: #171717;
}
.stroke-neutral-950 {
  stroke: #0a0a0a;
}
.stroke-orange-100 {
  stroke: #ffedd5;
}
.stroke-orange-200 {
  stroke: #fed7aa;
}
.stroke-orange-300 {
  stroke: #fdba74;
}
.stroke-orange-400 {
  stroke: #fb923c;
}
.stroke-orange-50 {
  stroke: #fff7ed;
}
.stroke-orange-500 {
  stroke: #f97316;
}
.stroke-orange-600 {
  stroke: #ea580c;
}
.stroke-orange-700 {
  stroke: #c2410c;
}
.stroke-orange-800 {
  stroke: #9a3412;
}
.stroke-orange-900 {
  stroke: #7c2d12;
}
.stroke-orange-950 {
  stroke: #431407;
}
.stroke-pink-100 {
  stroke: #fce7f3;
}
.stroke-pink-200 {
  stroke: #fbcfe8;
}
.stroke-pink-300 {
  stroke: #f9a8d4;
}
.stroke-pink-400 {
  stroke: #f472b6;
}
.stroke-pink-50 {
  stroke: #fdf2f8;
}
.stroke-pink-500 {
  stroke: #ec4899;
}
.stroke-pink-600 {
  stroke: #db2777;
}
.stroke-pink-700 {
  stroke: #be185d;
}
.stroke-pink-800 {
  stroke: #9d174d;
}
.stroke-pink-900 {
  stroke: #831843;
}
.stroke-pink-950 {
  stroke: #500724;
}
.stroke-purple-100 {
  stroke: #f3e8ff;
}
.stroke-purple-200 {
  stroke: #e9d5ff;
}
.stroke-purple-300 {
  stroke: #d8b4fe;
}
.stroke-purple-400 {
  stroke: #c084fc;
}
.stroke-purple-50 {
  stroke: #faf5ff;
}
.stroke-purple-500 {
  stroke: #a855f7;
}
.stroke-purple-600 {
  stroke: #9333ea;
}
.stroke-purple-700 {
  stroke: #7e22ce;
}
.stroke-purple-800 {
  stroke: #6b21a8;
}
.stroke-purple-900 {
  stroke: #581c87;
}
.stroke-purple-950 {
  stroke: #3b0764;
}
.stroke-red-100 {
  stroke: #fee2e2;
}
.stroke-red-200 {
  stroke: #fecaca;
}
.stroke-red-300 {
  stroke: #fca5a5;
}
.stroke-red-400 {
  stroke: #f87171;
}
.stroke-red-50 {
  stroke: #fef2f2;
}
.stroke-red-500 {
  stroke: #ef4444;
}
.stroke-red-600 {
  stroke: #dc2626;
}
.stroke-red-700 {
  stroke: #b91c1c;
}
.stroke-red-800 {
  stroke: #991b1b;
}
.stroke-red-900 {
  stroke: #7f1d1d;
}
.stroke-red-950 {
  stroke: #450a0a;
}
.stroke-rose-100 {
  stroke: #ffe4e6;
}
.stroke-rose-200 {
  stroke: #fecdd3;
}
.stroke-rose-300 {
  stroke: #fda4af;
}
.stroke-rose-400 {
  stroke: #fb7185;
}
.stroke-rose-50 {
  stroke: #fff1f2;
}
.stroke-rose-500 {
  stroke: #f43f5e;
}
.stroke-rose-600 {
  stroke: #e11d48;
}
.stroke-rose-700 {
  stroke: #be123c;
}
.stroke-rose-800 {
  stroke: #9f1239;
}
.stroke-rose-900 {
  stroke: #881337;
}
.stroke-rose-950 {
  stroke: #4c0519;
}
.stroke-sky-100 {
  stroke: #e0f2fe;
}
.stroke-sky-200 {
  stroke: #bae6fd;
}
.stroke-sky-300 {
  stroke: #7dd3fc;
}
.stroke-sky-400 {
  stroke: #38bdf8;
}
.stroke-sky-50 {
  stroke: #f0f9ff;
}
.stroke-sky-500 {
  stroke: #0ea5e9;
}
.stroke-sky-600 {
  stroke: #0284c7;
}
.stroke-sky-700 {
  stroke: #0369a1;
}
.stroke-sky-800 {
  stroke: #075985;
}
.stroke-sky-900 {
  stroke: #0c4a6e;
}
.stroke-sky-950 {
  stroke: #082f49;
}
.stroke-slate-100 {
  stroke: #f1f5f9;
}
.stroke-slate-200 {
  stroke: #e2e8f0;
}
.stroke-slate-300 {
  stroke: #cbd5e1;
}
.stroke-slate-400 {
  stroke: #94a3b8;
}
.stroke-slate-50 {
  stroke: #f8fafc;
}
.stroke-slate-500 {
  stroke: #64748b;
}
.stroke-slate-600 {
  stroke: #475569;
}
.stroke-slate-700 {
  stroke: #334155;
}
.stroke-slate-800 {
  stroke: #1e293b;
}
.stroke-slate-900 {
  stroke: #0f172a;
}
.stroke-slate-950 {
  stroke: #020617;
}
.stroke-stone-100 {
  stroke: #f5f5f4;
}
.stroke-stone-200 {
  stroke: #e7e5e4;
}
.stroke-stone-300 {
  stroke: #d6d3d1;
}
.stroke-stone-400 {
  stroke: #a8a29e;
}
.stroke-stone-50 {
  stroke: #fafaf9;
}
.stroke-stone-500 {
  stroke: #78716c;
}
.stroke-stone-600 {
  stroke: #57534e;
}
.stroke-stone-700 {
  stroke: #44403c;
}
.stroke-stone-800 {
  stroke: #292524;
}
.stroke-stone-900 {
  stroke: #1c1917;
}
.stroke-stone-950 {
  stroke: #0c0a09;
}
.stroke-teal-100 {
  stroke: #ccfbf1;
}
.stroke-teal-200 {
  stroke: #99f6e4;
}
.stroke-teal-300 {
  stroke: #5eead4;
}
.stroke-teal-400 {
  stroke: #2dd4bf;
}
.stroke-teal-50 {
  stroke: #f0fdfa;
}
.stroke-teal-500 {
  stroke: #14b8a6;
}
.stroke-teal-600 {
  stroke: #0d9488;
}
.stroke-teal-700 {
  stroke: #0f766e;
}
.stroke-teal-800 {
  stroke: #115e59;
}
.stroke-teal-900 {
  stroke: #134e4a;
}
.stroke-teal-950 {
  stroke: #042f2e;
}
.stroke-tremor-background {
  stroke: #fff;
}
.stroke-tremor-border {
  stroke: #e5e7eb;
}
.stroke-tremor-brand {
  stroke: #3b82f6;
}
.stroke-tremor-brand-muted\\/50 {
  stroke: rgb(191 219 254 / 0.5);
}
.stroke-violet-100 {
  stroke: #ede9fe;
}
.stroke-violet-200 {
  stroke: #ddd6fe;
}
.stroke-violet-300 {
  stroke: #c4b5fd;
}
.stroke-violet-400 {
  stroke: #a78bfa;
}
.stroke-violet-50 {
  stroke: #f5f3ff;
}
.stroke-violet-500 {
  stroke: #8b5cf6;
}
.stroke-violet-600 {
  stroke: #7c3aed;
}
.stroke-violet-700 {
  stroke: #6d28d9;
}
.stroke-violet-800 {
  stroke: #5b21b6;
}
.stroke-violet-900 {
  stroke: #4c1d95;
}
.stroke-violet-950 {
  stroke: #2e1065;
}
.stroke-yellow-100 {
  stroke: #fef9c3;
}
.stroke-yellow-200 {
  stroke: #fef08a;
}
.stroke-yellow-300 {
  stroke: #fde047;
}
.stroke-yellow-400 {
  stroke: #facc15;
}
.stroke-yellow-50 {
  stroke: #fefce8;
}
.stroke-yellow-500 {
  stroke: #eab308;
}
.stroke-yellow-600 {
  stroke: #ca8a04;
}
.stroke-yellow-700 {
  stroke: #a16207;
}
.stroke-yellow-800 {
  stroke: #854d0e;
}
.stroke-yellow-900 {
  stroke: #713f12;
}
.stroke-yellow-950 {
  stroke: #422006;
}
.stroke-zinc-100 {
  stroke: #f4f4f5;
}
.stroke-zinc-200 {
  stroke: #e4e4e7;
}
.stroke-zinc-300 {
  stroke: #d4d4d8;
}
.stroke-zinc-400 {
  stroke: #a1a1aa;
}
.stroke-zinc-50 {
  stroke: #fafafa;
}
.stroke-zinc-500 {
  stroke: #71717a;
}
.stroke-zinc-600 {
  stroke: #52525b;
}
.stroke-zinc-700 {
  stroke: #3f3f46;
}
.stroke-zinc-800 {
  stroke: #27272a;
}
.stroke-zinc-900 {
  stroke: #18181b;
}
.stroke-zinc-950 {
  stroke: #09090b;
}
.stroke-1 {
  stroke-width: 1;
}
.object-cover {
  object-fit: cover;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-3 {
  padding: 0.75rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[18px\\] {
  padding-bottom: 18px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-14 {
  padding-left: 3.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pr-0\\.5 {
  padding-right: 0.125rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[18px\\] {
  padding-right: 18px;
}
.pr-\\[2\\.5rem\\] {
  padding-right: 2.5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-sm {
  font-size: 0.875rem !important;
  line-height: 1.25rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[0\\.65rem\\] {
  font-size: 0.65rem;
}
.text-\\[0\\.6rem\\] {
  font-size: 0.6rem;
}
.text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-icon-md {
  font-size: 1.3rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-tremor-default {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-tremor-label {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-tremor-metric {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-tremor-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4 {
  line-height: 1rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[1\\.143rem\\] {
  line-height: 1.143rem;
}
.leading-\\[1\\.5rem\\] {
  line-height: 1.5rem;
}
.leading-\\[2\\.25rem\\] {
  line-height: 2.25rem;
}
.leading-\\[3rem\\] {
  line-height: 3rem;
}
.leading-none {
  line-height: 1;
}
.leading-tight {
  line-height: 1.25;
}
.\\!text-\\[\\#5a5555\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(90 85 85 / var(--tw-text-opacity)) !important;
}
.\\!text-rose-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(190 18 60 / var(--tw-text-opacity)) !important;
}
.\\!text-secondary {
  --tw-text-opacity: 1 !important;
  color: rgb(0 75 141 / var(--tw-text-opacity)) !important;
}
.\\!text-tremor-content {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#0277BD\\] {
  --tw-text-opacity: 1;
  color: rgb(2 119 189 / var(--tw-text-opacity));
}
.text-\\[\\#2E7D32\\] {
  --tw-text-opacity: 1;
  color: rgb(46 125 50 / var(--tw-text-opacity));
}
.text-\\[\\#334155\\] {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.text-\\[\\#616161\\] {
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-\\[\\#e20221\\] {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.text-\\[\\#ffcc33\\] {
  --tw-text-opacity: 1;
  color: rgb(255 204 51 / var(--tw-text-opacity));
}
.text-amber-100 {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity));
}
.text-amber-200 {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.text-amber-50 {
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.text-blue-50 {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-blue-950 {
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity));
}
.text-cyan-100 {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity));
}
.text-cyan-200 {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity));
}
.text-cyan-50 {
  --tw-text-opacity: 1;
  color: rgb(236 254 255 / var(--tw-text-opacity));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}
.text-cyan-950 {
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity));
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity));
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.text-emerald-50 {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
.text-emerald-950 {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.text-fuchsia-100 {
  --tw-text-opacity: 1;
  color: rgb(250 232 255 / var(--tw-text-opacity));
}
.text-fuchsia-200 {
  --tw-text-opacity: 1;
  color: rgb(245 208 254 / var(--tw-text-opacity));
}
.text-fuchsia-300 {
  --tw-text-opacity: 1;
  color: rgb(240 171 252 / var(--tw-text-opacity));
}
.text-fuchsia-400 {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity));
}
.text-fuchsia-50 {
  --tw-text-opacity: 1;
  color: rgb(253 244 255 / var(--tw-text-opacity));
}
.text-fuchsia-500 {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
.text-fuchsia-600 {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity));
}
.text-fuchsia-700 {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity));
}
.text-fuchsia-800 {
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / var(--tw-text-opacity));
}
.text-fuchsia-900 {
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / var(--tw-text-opacity));
}
.text-fuchsia-950 {
  --tw-text-opacity: 1;
  color: rgb(74 4 78 / var(--tw-text-opacity));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity));
}
.text-green-100 {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity));
}
.text-green-200 {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity));
}
.text-green-300 {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
.text-green-50 {
  --tw-text-opacity: 1;
  color: rgb(240 253 244 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
.text-green-950 {
  --tw-text-opacity: 1;
  color: rgb(5 46 22 / var(--tw-text-opacity));
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity));
}
.text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}
.text-indigo-50 {
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity));
}
.text-indigo-950 {
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-lime-100 {
  --tw-text-opacity: 1;
  color: rgb(236 252 203 / var(--tw-text-opacity));
}
.text-lime-200 {
  --tw-text-opacity: 1;
  color: rgb(217 249 157 / var(--tw-text-opacity));
}
.text-lime-300 {
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / var(--tw-text-opacity));
}
.text-lime-400 {
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / var(--tw-text-opacity));
}
.text-lime-50 {
  --tw-text-opacity: 1;
  color: rgb(247 254 231 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.text-lime-600 {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}
.text-lime-950 {
  --tw-text-opacity: 1;
  color: rgb(26 46 5 / var(--tw-text-opacity));
}
.text-neutral-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.text-neutral-200 {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}
.text-neutral-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}
.text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
.text-neutral-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}
.text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
.text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity));
}
.text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity));
}
.text-neutral-950 {
  --tw-text-opacity: 1;
  color: rgb(10 10 10 / var(--tw-text-opacity));
}
.text-orange-100 {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity));
}
.text-orange-200 {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
.text-orange-50 {
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity));
}
.text-orange-950 {
  --tw-text-opacity: 1;
  color: rgb(67 20 7 / var(--tw-text-opacity));
}
.text-pink-100 {
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity));
}
.text-pink-200 {
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity));
}
.text-pink-300 {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity));
}
.text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity));
}
.text-pink-50 {
  --tw-text-opacity: 1;
  color: rgb(253 242 248 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity));
}
.text-pink-950 {
  --tw-text-opacity: 1;
  color: rgb(80 7 36 / var(--tw-text-opacity));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity));
}
.text-purple-200 {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}
.text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity));
}
.text-purple-50 {
  --tw-text-opacity: 1;
  color: rgb(250 245 255 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity));
}
.text-purple-950 {
  --tw-text-opacity: 1;
  color: rgb(59 7 100 / var(--tw-text-opacity));
}
.text-red-100 {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity));
}
.text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.text-red-50 {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.text-red-950 {
  --tw-text-opacity: 1;
  color: rgb(69 10 10 / var(--tw-text-opacity));
}
.text-rose-100 {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity));
}
.text-rose-200 {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity));
}
.text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
.text-rose-50 {
  --tw-text-opacity: 1;
  color: rgb(255 241 242 / var(--tw-text-opacity));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
.text-rose-800 {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity));
}
.text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity));
}
.text-rose-950 {
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(0 75 141 / var(--tw-text-opacity));
}
.text-sky-100 {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity));
}
.text-sky-200 {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity));
}
.text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
.text-sky-400 {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity));
}
.text-sky-50 {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity));
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity));
}
.text-sky-900 {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity));
}
.text-sky-950 {
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity));
}
.text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.text-slate-50 {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.text-slate-950 {
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity));
}
.text-stone-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 244 / var(--tw-text-opacity));
}
.text-stone-200 {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
.text-stone-300 {
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity));
}
.text-stone-400 {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity));
}
.text-stone-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / var(--tw-text-opacity));
}
.text-stone-500 {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity));
}
.text-stone-600 {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity));
}
.text-stone-700 {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity));
}
.text-stone-800 {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity));
}
.text-stone-900 {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity));
}
.text-stone-950 {
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity));
}
.text-teal-100 {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity));
}
.text-teal-200 {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity));
}
.text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity));
}
.text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity));
}
.text-teal-50 {
  --tw-text-opacity: 1;
  color: rgb(240 253 250 / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity));
}
.text-teal-950 {
  --tw-text-opacity: 1;
  color: rgb(4 47 46 / var(--tw-text-opacity));
}
.text-tremor-brand {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-tremor-brand-emphasis {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.text-tremor-brand-inverted {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-tremor-content {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-tremor-content-emphasis {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-tremor-content-subtle {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-violet-100 {
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity));
}
.text-violet-200 {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity));
}
.text-violet-300 {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity));
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity));
}
.text-violet-50 {
  --tw-text-opacity: 1;
  color: rgb(245 243 255 / var(--tw-text-opacity));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity));
}
.text-violet-900 {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity));
}
.text-violet-950 {
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-yellow-100 {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity));
}
.text-yellow-200 {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity));
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}
.text-yellow-50 {
  --tw-text-opacity: 1;
  color: rgb(254 252 232 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity));
}
.text-yellow-950 {
  --tw-text-opacity: 1;
  color: rgb(66 32 6 / var(--tw-text-opacity));
}
.text-zinc-100 {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
.text-zinc-200 {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}
.text-zinc-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.text-zinc-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.text-zinc-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.text-zinc-700 {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
.text-zinc-800 {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity));
}
.text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity));
}
.text-zinc-950 {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.accent-tremor-brand {
  accent-color: #3b82f6;
}
.\\!opacity-0 {
  opacity: 0 !important;
}
.\\!opacity-100 {
  opacity: 1 !important;
}
.\\!opacity-90 {
  opacity: 0.9 !important;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-85 {
  opacity: 0.85;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_0\\.2rem_rgba\\(191\\2c 219\\2c 254\\2c 1\\)\\] {
  --tw-shadow: 0 0 0 0.2rem rgba(191,219,254,1);
  --tw-shadow-colored: 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.1\\)\\] {
  --tw-shadow: 0 2px 12px rgba(0,0,0,0.1);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-tremor-card {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-tremor-dropdown {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-tremor-input {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-offset-0 {
  outline-offset: 0px;
}
.outline-tremor-brand {
  outline-color: #3b82f6;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#e20221\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 2 33 / var(--tw-ring-opacity));
}
.ring-\\[\\#ffcc33\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 204 51 / var(--tw-ring-opacity));
}
.ring-amber-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 243 199 / var(--tw-ring-opacity));
}
.ring-amber-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity));
}
.ring-amber-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 211 77 / var(--tw-ring-opacity));
}
.ring-amber-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity));
}
.ring-amber-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 251 235 / var(--tw-ring-opacity));
}
.ring-amber-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity));
}
.ring-amber-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 119 6 / var(--tw-ring-opacity));
}
.ring-amber-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 83 9 / var(--tw-ring-opacity));
}
.ring-amber-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(146 64 14 / var(--tw-ring-opacity));
}
.ring-amber-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(120 53 15 / var(--tw-ring-opacity));
}
.ring-amber-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(69 26 3 / var(--tw-ring-opacity));
}
.ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity));
}
.ring-blue-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity));
}
.ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity));
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity));
}
.ring-blue-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 246 255 / var(--tw-ring-opacity));
}
.ring-blue-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
.ring-blue-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity));
}
.ring-blue-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(29 78 216 / var(--tw-ring-opacity));
}
.ring-blue-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity));
}
.ring-blue-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 58 138 / var(--tw-ring-opacity));
}
.ring-blue-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(23 37 84 / var(--tw-ring-opacity));
}
.ring-cyan-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(207 250 254 / var(--tw-ring-opacity));
}
.ring-cyan-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity));
}
.ring-cyan-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(103 232 249 / var(--tw-ring-opacity));
}
.ring-cyan-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity));
}
.ring-cyan-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 254 255 / var(--tw-ring-opacity));
}
.ring-cyan-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity));
}
.ring-cyan-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity));
}
.ring-cyan-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity));
}
.ring-cyan-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity));
}
.ring-cyan-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 78 99 / var(--tw-ring-opacity));
}
.ring-cyan-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 51 68 / var(--tw-ring-opacity));
}
.ring-emerald-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity));
}
.ring-emerald-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity));
}
.ring-emerald-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(110 231 183 / var(--tw-ring-opacity));
}
.ring-emerald-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity));
}
.ring-emerald-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 253 245 / var(--tw-ring-opacity));
}
.ring-emerald-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity));
}
.ring-emerald-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 150 105 / var(--tw-ring-opacity));
}
.ring-emerald-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 120 87 / var(--tw-ring-opacity));
}
.ring-emerald-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 95 70 / var(--tw-ring-opacity));
}
.ring-emerald-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 78 59 / var(--tw-ring-opacity));
}
.ring-emerald-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(2 44 34 / var(--tw-ring-opacity));
}
.ring-fuchsia-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 232 255 / var(--tw-ring-opacity));
}
.ring-fuchsia-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 208 254 / var(--tw-ring-opacity));
}
.ring-fuchsia-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 171 252 / var(--tw-ring-opacity));
}
.ring-fuchsia-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(232 121 249 / var(--tw-ring-opacity));
}
.ring-fuchsia-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 244 255 / var(--tw-ring-opacity));
}
.ring-fuchsia-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 70 239 / var(--tw-ring-opacity));
}
.ring-fuchsia-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 38 211 / var(--tw-ring-opacity));
}
.ring-fuchsia-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(162 28 175 / var(--tw-ring-opacity));
}
.ring-fuchsia-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 25 143 / var(--tw-ring-opacity));
}
.ring-fuchsia-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(112 26 117 / var(--tw-ring-opacity));
}
.ring-fuchsia-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 4 78 / var(--tw-ring-opacity));
}
.ring-gray-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity));
}
.ring-gray-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity));
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity));
}
.ring-gray-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity));
}
.ring-gray-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 250 251 / var(--tw-ring-opacity));
}
.ring-gray-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
}
.ring-gray-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
}
.ring-gray-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity));
}
.ring-gray-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity));
}
.ring-gray-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity));
}
.ring-gray-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 7 18 / var(--tw-ring-opacity));
}
.ring-green-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 252 231 / var(--tw-ring-opacity));
}
.ring-green-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity));
}
.ring-green-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity));
}
.ring-green-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 222 128 / var(--tw-ring-opacity));
}
.ring-green-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 253 244 / var(--tw-ring-opacity));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity));
}
.ring-green-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 163 74 / var(--tw-ring-opacity));
}
.ring-green-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 128 61 / var(--tw-ring-opacity));
}
.ring-green-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 101 52 / var(--tw-ring-opacity));
}
.ring-green-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 83 45 / var(--tw-ring-opacity));
}
.ring-green-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 46 22 / var(--tw-ring-opacity));
}
.ring-indigo-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity));
}
.ring-indigo-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(199 210 254 / var(--tw-ring-opacity));
}
.ring-indigo-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 180 252 / var(--tw-ring-opacity));
}
.ring-indigo-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity));
}
.ring-indigo-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(238 242 255 / var(--tw-ring-opacity));
}
.ring-indigo-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}
.ring-indigo-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(79 70 229 / var(--tw-ring-opacity));
}
.ring-indigo-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(67 56 202 / var(--tw-ring-opacity));
}
.ring-indigo-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 48 163 / var(--tw-ring-opacity));
}
.ring-indigo-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 46 129 / var(--tw-ring-opacity));
}
.ring-indigo-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 27 75 / var(--tw-ring-opacity));
}
.ring-lime-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 252 203 / var(--tw-ring-opacity));
}
.ring-lime-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 249 157 / var(--tw-ring-opacity));
}
.ring-lime-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 242 100 / var(--tw-ring-opacity));
}
.ring-lime-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 230 53 / var(--tw-ring-opacity));
}
.ring-lime-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(247 254 231 / var(--tw-ring-opacity));
}
.ring-lime-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 204 22 / var(--tw-ring-opacity));
}
.ring-lime-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(101 163 13 / var(--tw-ring-opacity));
}
.ring-lime-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity));
}
.ring-lime-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 98 18 / var(--tw-ring-opacity));
}
.ring-lime-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(54 83 20 / var(--tw-ring-opacity));
}
.ring-lime-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 46 5 / var(--tw-ring-opacity));
}
.ring-neutral-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 245 245 / var(--tw-ring-opacity));
}
.ring-neutral-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 229 229 / var(--tw-ring-opacity));
}
.ring-neutral-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(212 212 212 / var(--tw-ring-opacity));
}
.ring-neutral-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 163 163 / var(--tw-ring-opacity));
}
.ring-neutral-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 250 250 / var(--tw-ring-opacity));
}
.ring-neutral-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(115 115 115 / var(--tw-ring-opacity));
}
.ring-neutral-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(82 82 82 / var(--tw-ring-opacity));
}
.ring-neutral-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(64 64 64 / var(--tw-ring-opacity));
}
.ring-neutral-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(38 38 38 / var(--tw-ring-opacity));
}
.ring-neutral-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(23 23 23 / var(--tw-ring-opacity));
}
.ring-neutral-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(10 10 10 / var(--tw-ring-opacity));
}
.ring-orange-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 237 213 / var(--tw-ring-opacity));
}
.ring-orange-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 215 170 / var(--tw-ring-opacity));
}
.ring-orange-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 186 116 / var(--tw-ring-opacity));
}
.ring-orange-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 146 60 / var(--tw-ring-opacity));
}
.ring-orange-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 247 237 / var(--tw-ring-opacity));
}
.ring-orange-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity));
}
.ring-orange-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(234 88 12 / var(--tw-ring-opacity));
}
.ring-orange-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 65 12 / var(--tw-ring-opacity));
}
.ring-orange-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(154 52 18 / var(--tw-ring-opacity));
}
.ring-orange-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 45 18 / var(--tw-ring-opacity));
}
.ring-orange-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(67 20 7 / var(--tw-ring-opacity));
}
.ring-pink-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 231 243 / var(--tw-ring-opacity));
}
.ring-pink-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 207 232 / var(--tw-ring-opacity));
}
.ring-pink-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 168 212 / var(--tw-ring-opacity));
}
.ring-pink-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 114 182 / var(--tw-ring-opacity));
}
.ring-pink-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 242 248 / var(--tw-ring-opacity));
}
.ring-pink-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity));
}
.ring-pink-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 39 119 / var(--tw-ring-opacity));
}
.ring-pink-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 24 93 / var(--tw-ring-opacity));
}
.ring-pink-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(157 23 77 / var(--tw-ring-opacity));
}
.ring-pink-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(131 24 67 / var(--tw-ring-opacity));
}
.ring-pink-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(80 7 36 / var(--tw-ring-opacity));
}
.ring-purple-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 232 255 / var(--tw-ring-opacity));
}
.ring-purple-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity));
}
.ring-purple-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(216 180 254 / var(--tw-ring-opacity));
}
.ring-purple-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity));
}
.ring-purple-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 245 255 / var(--tw-ring-opacity));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity));
}
.ring-purple-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 51 234 / var(--tw-ring-opacity));
}
.ring-purple-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 34 206 / var(--tw-ring-opacity));
}
.ring-purple-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 33 168 / var(--tw-ring-opacity));
}
.ring-purple-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(88 28 135 / var(--tw-ring-opacity));
}
.ring-purple-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 7 100 / var(--tw-ring-opacity));
}
.ring-red-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 226 226 / var(--tw-ring-opacity));
}
.ring-red-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity));
}
.ring-red-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity));
}
.ring-red-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity));
}
.ring-red-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 242 242 / var(--tw-ring-opacity));
}
.ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}
.ring-red-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 38 38 / var(--tw-ring-opacity));
}
.ring-red-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(185 28 28 / var(--tw-ring-opacity));
}
.ring-red-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 27 27 / var(--tw-ring-opacity));
}
.ring-red-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(127 29 29 / var(--tw-ring-opacity));
}
.ring-red-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(69 10 10 / var(--tw-ring-opacity));
}
.ring-rose-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 228 230 / var(--tw-ring-opacity));
}
.ring-rose-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity));
}
.ring-rose-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity));
}
.ring-rose-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity));
}
.ring-rose-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 241 242 / var(--tw-ring-opacity));
}
.ring-rose-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 63 94 / var(--tw-ring-opacity));
}
.ring-rose-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(225 29 72 / var(--tw-ring-opacity));
}
.ring-rose-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 18 60 / var(--tw-ring-opacity));
}
.ring-rose-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 18 57 / var(--tw-ring-opacity));
}
.ring-rose-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(136 19 55 / var(--tw-ring-opacity));
}
.ring-rose-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(76 5 25 / var(--tw-ring-opacity));
}
.ring-sky-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 242 254 / var(--tw-ring-opacity));
}
.ring-sky-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity));
}
.ring-sky-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(125 211 252 / var(--tw-ring-opacity));
}
.ring-sky-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(56 189 248 / var(--tw-ring-opacity));
}
.ring-sky-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 249 255 / var(--tw-ring-opacity));
}
.ring-sky-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity));
}
.ring-sky-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(2 132 199 / var(--tw-ring-opacity));
}
.ring-sky-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 105 161 / var(--tw-ring-opacity));
}
.ring-sky-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(7 89 133 / var(--tw-ring-opacity));
}
.ring-sky-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(12 74 110 / var(--tw-ring-opacity));
}
.ring-sky-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 47 73 / var(--tw-ring-opacity));
}
.ring-slate-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 245 249 / var(--tw-ring-opacity));
}
.ring-slate-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity));
}
.ring-slate-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(203 213 225 / var(--tw-ring-opacity));
}
.ring-slate-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(148 163 184 / var(--tw-ring-opacity));
}
.ring-slate-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 250 252 / var(--tw-ring-opacity));
}
.ring-slate-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(100 116 139 / var(--tw-ring-opacity));
}
.ring-slate-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(71 85 105 / var(--tw-ring-opacity));
}
.ring-slate-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 65 85 / var(--tw-ring-opacity));
}
.ring-slate-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 41 59 / var(--tw-ring-opacity));
}
.ring-slate-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 23 42 / var(--tw-ring-opacity));
}
.ring-slate-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(2 6 23 / var(--tw-ring-opacity));
}
.ring-stone-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 245 244 / var(--tw-ring-opacity));
}
.ring-stone-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 229 228 / var(--tw-ring-opacity));
}
.ring-stone-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 211 209 / var(--tw-ring-opacity));
}
.ring-stone-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 162 158 / var(--tw-ring-opacity));
}
.ring-stone-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 250 249 / var(--tw-ring-opacity));
}
.ring-stone-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(120 113 108 / var(--tw-ring-opacity));
}
.ring-stone-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(87 83 78 / var(--tw-ring-opacity));
}
.ring-stone-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(68 64 60 / var(--tw-ring-opacity));
}
.ring-stone-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(41 37 36 / var(--tw-ring-opacity));
}
.ring-stone-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 25 23 / var(--tw-ring-opacity));
}
.ring-stone-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(12 10 9 / var(--tw-ring-opacity));
}
.ring-teal-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(204 251 241 / var(--tw-ring-opacity));
}
.ring-teal-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 246 228 / var(--tw-ring-opacity));
}
.ring-teal-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(94 234 212 / var(--tw-ring-opacity));
}
.ring-teal-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(45 212 191 / var(--tw-ring-opacity));
}
.ring-teal-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 253 250 / var(--tw-ring-opacity));
}
.ring-teal-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity));
}
.ring-teal-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(13 148 136 / var(--tw-ring-opacity));
}
.ring-teal-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(15 118 110 / var(--tw-ring-opacity));
}
.ring-teal-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 94 89 / var(--tw-ring-opacity));
}
.ring-teal-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(19 78 74 / var(--tw-ring-opacity));
}
.ring-teal-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 47 46 / var(--tw-ring-opacity));
}
.ring-tremor-brand-inverted {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-tremor-brand-muted {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity));
}
.ring-tremor-ring {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity));
}
.ring-violet-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(237 233 254 / var(--tw-ring-opacity));
}
.ring-violet-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(221 214 254 / var(--tw-ring-opacity));
}
.ring-violet-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity));
}
.ring-violet-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity));
}
.ring-violet-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 243 255 / var(--tw-ring-opacity));
}
.ring-violet-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity));
}
.ring-violet-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(124 58 237 / var(--tw-ring-opacity));
}
.ring-violet-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(109 40 217 / var(--tw-ring-opacity));
}
.ring-violet-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(91 33 182 / var(--tw-ring-opacity));
}
.ring-violet-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(76 29 149 / var(--tw-ring-opacity));
}
.ring-violet-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(46 16 101 / var(--tw-ring-opacity));
}
.ring-yellow-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 249 195 / var(--tw-ring-opacity));
}
.ring-yellow-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 240 138 / var(--tw-ring-opacity));
}
.ring-yellow-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 224 71 / var(--tw-ring-opacity));
}
.ring-yellow-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 204 21 / var(--tw-ring-opacity));
}
.ring-yellow-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 252 232 / var(--tw-ring-opacity));
}
.ring-yellow-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(234 179 8 / var(--tw-ring-opacity));
}
.ring-yellow-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 138 4 / var(--tw-ring-opacity));
}
.ring-yellow-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(161 98 7 / var(--tw-ring-opacity));
}
.ring-yellow-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(133 77 14 / var(--tw-ring-opacity));
}
.ring-yellow-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(113 63 18 / var(--tw-ring-opacity));
}
.ring-yellow-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(66 32 6 / var(--tw-ring-opacity));
}
.ring-zinc-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 244 245 / var(--tw-ring-opacity));
}
.ring-zinc-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(228 228 231 / var(--tw-ring-opacity));
}
.ring-zinc-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(212 212 216 / var(--tw-ring-opacity));
}
.ring-zinc-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(161 161 170 / var(--tw-ring-opacity));
}
.ring-zinc-50 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 250 250 / var(--tw-ring-opacity));
}
.ring-zinc-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(113 113 122 / var(--tw-ring-opacity));
}
.ring-zinc-600 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(82 82 91 / var(--tw-ring-opacity));
}
.ring-zinc-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 63 70 / var(--tw-ring-opacity));
}
.ring-zinc-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(39 39 42 / var(--tw-ring-opacity));
}
.ring-zinc-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(24 24 27 / var(--tw-ring-opacity));
}
.ring-zinc-950 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(9 9 11 / var(--tw-ring-opacity));
}
.ring-opacity-40 {
  --tw-ring-opacity: 0.4;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!transition-none {
  transition-property: none !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-1000 {
  transition-delay: 1000ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.duration-\\[250ms\\] {
  transition-duration: 250ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-linear {
  transition-timing-function: linear;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[appearance\\:textfield\\] {
  appearance: textfield;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

body {
  line-height: 1.2;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.placeholder\\:text-tremor-content::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.placeholder\\:text-tremor-content-subtle::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:-top-3::before {
  content: var(--tw-content);
  top: -0.75rem;
}
.before\\:bottom-0::before {
  content: var(--tw-content);
  bottom: 0px;
}
.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
.before\\:left-1::before {
  content: var(--tw-content);
  left: 0.25rem;
}
.before\\:left-1\\/2::before {
  content: var(--tw-content);
  left: 50%;
}
.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}
.before\\:top-1\\/2::before {
  content: var(--tw-content);
  top: 50%;
}
.before\\:top-1\\/4::before {
  content: var(--tw-content);
  top: 25%;
}
.before\\:-mt-2::before {
  content: var(--tw-content);
  margin-top: -0.5rem;
}
.before\\:-mt-2\\.5::before {
  content: var(--tw-content);
  margin-top: -0.625rem;
}
.before\\:ml-6::before {
  content: var(--tw-content);
  margin-left: 1.5rem;
}
.before\\:block::before {
  content: var(--tw-content);
  display: block;
}
.before\\:h-0::before {
  content: var(--tw-content);
  height: 0px;
}
.before\\:h-5::before {
  content: var(--tw-content);
  height: 1.25rem;
}
.before\\:min-h-full::before {
  content: var(--tw-content);
  min-height: 100%;
}
.before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}
.before\\:w-5::before {
  content: var(--tw-content);
  width: 1.25rem;
}
.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}
.before\\:-translate-x-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:-translate-y-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:translate-x-5::before {
  content: var(--tw-content);
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:transform::before {
  content: var(--tw-content);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:border-x-\\[0\\.75rem\\]::before {
  content: var(--tw-content);
  border-left-width: 0.75rem;
  border-right-width: 0.75rem;
}
.before\\:border-b-\\[0\\.75rem\\]::before {
  content: var(--tw-content);
  border-bottom-width: 0.75rem;
}
.before\\:border-l::before {
  content: var(--tw-content);
  border-left-width: 1px;
}
.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:border-t-0::before {
  content: var(--tw-content);
  border-top-width: 0px;
}
.before\\:border-solid::before {
  content: var(--tw-content);
  border-style: solid;
}
.before\\:border-dashed::before {
  content: var(--tw-content);
  border-style: dashed;
}
.before\\:border-dotted::before {
  content: var(--tw-content);
  border-style: dotted;
}
.before\\:border-gray-300::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}
.before\\:border-b-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.before\\:bg-inherit::before {
  content: var(--tw-content);
  background-color: inherit;
}
.before\\:bg-white::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:left-0::after {
  content: var(--tw-content);
  left: 0px;
}
.after\\:left-full::after {
  content: var(--tw-content);
  left: 100%;
}
.after\\:right-0::after {
  content: var(--tw-content);
  right: 0px;
}
.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}
.after\\:z-10::after {
  content: var(--tw-content);
  z-index: 10;
}
.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:transform::after {
  content: var(--tw-content);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:bg-blue-400::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.after\\:bg-inherit::after {
  content: var(--tw-content);
  background-color: inherit;
}
.after\\:bg-gradient-to-r::after {
  content: var(--tw-content);
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.after\\:from-transparent::after {
  content: var(--tw-content);
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.after\\:via-white::after {
  content: var(--tw-content);
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.after\\:to-transparent::after {
  content: var(--tw-content);
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.after\\:delay-1000::after {
  content: var(--tw-content);
  transition-delay: 1000ms;
}
.first\\:mb-2:first-child {
  margin-bottom: 0.5rem;
}
.first\\:ml-2:first-child {
  margin-left: 0.5rem;
}
.first\\:mr-2:first-child {
  margin-right: 0.5rem;
}
.first\\:mt-2:first-child {
  margin-top: 0.5rem;
}
.first\\:rounded-l-\\[4px\\]:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.first\\:rounded-br-none:first-child {
  border-bottom-right-radius: 0px;
}
.first\\:rounded-tr-none:first-child {
  border-top-right-radius: 0px;
}
.first\\:border-l-0:first-child {
  border-left-width: 0px;
}
.first\\:pl-0:first-child {
  padding-left: 0px;
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:mr-0:last-child {
  margin-right: 0px;
}
.last\\:rounded-r-\\[4px\\]:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.last\\:rounded-bl-lg:last-child {
  border-bottom-left-radius: 0.5rem;
}
.last\\:rounded-bl-none:last-child {
  border-bottom-left-radius: 0px;
}
.last\\:rounded-br-lg:last-child {
  border-bottom-right-radius: 0.5rem;
}
.last\\:rounded-tl-none:last-child {
  border-top-left-radius: 0px;
}
.last\\:border-r:last-child {
  border-right-width: 1px;
}
.even\\:bg-gray-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.hover\\:mx-6:hover {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.hover\\:my-6:hover {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-150:hover {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:transform:hover {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:cursor-pointer:hover {
  cursor: pointer;
}
.hover\\:border:hover {
  border-width: 1px;
}
.hover\\:border-b-2:hover {
  border-bottom-width: 2px;
}
.hover\\:border-solid:hover {
  border-style: solid;
}
.hover\\:\\!border-blue-500:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(59 130 246 / var(--tw-border-opacity)) !important;
}
.hover\\:border-\\[\\#e20221\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
.hover\\:border-\\[\\#ffcc33\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 204 51 / var(--tw-border-opacity));
}
.hover\\:border-amber-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity));
}
.hover\\:border-amber-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.hover\\:border-amber-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity));
}
.hover\\:border-amber-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 251 235 / var(--tw-border-opacity));
}
.hover\\:border-amber-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.hover\\:border-amber-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity));
}
.hover\\:border-amber-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity));
}
.hover\\:border-amber-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity));
}
.hover\\:border-amber-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity));
}
.hover\\:border-amber-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(69 26 3 / var(--tw-border-opacity));
}
.hover\\:border-blue-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity));
}
.hover\\:border-blue-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.hover\\:border-blue-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.hover\\:border-blue-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity));
}
.hover\\:border-blue-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.hover\\:border-blue-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.hover\\:border-blue-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}
.hover\\:border-blue-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
.hover\\:border-blue-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(23 37 84 / var(--tw-border-opacity));
}
.hover\\:border-cyan-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity));
}
.hover\\:border-cyan-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity));
}
.hover\\:border-cyan-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.hover\\:border-cyan-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity));
}
.hover\\:border-cyan-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(236 254 255 / var(--tw-border-opacity));
}
.hover\\:border-cyan-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.hover\\:border-cyan-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}
.hover\\:border-cyan-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}
.hover\\:border-cyan-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity));
}
.hover\\:border-cyan-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / var(--tw-border-opacity));
}
.hover\\:border-cyan-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(8 51 68 / var(--tw-border-opacity));
}
.hover\\:border-emerald-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity));
}
.hover\\:border-emerald-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
.hover\\:border-emerald-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.hover\\:border-emerald-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.hover\\:border-emerald-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity));
}
.hover\\:border-emerald-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.hover\\:border-emerald-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
.hover\\:border-emerald-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
.hover\\:border-emerald-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity));
}
.hover\\:border-emerald-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity));
}
.hover\\:border-emerald-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(2 44 34 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 232 255 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(240 171 252 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 244 255 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(192 38 211 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(162 28 175 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / var(--tw-border-opacity));
}
.hover\\:border-fuchsia-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(74 4 78 / var(--tw-border-opacity));
}
.hover\\:border-gray-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.hover\\:border-gray-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.hover\\:border-gray-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
.hover\\:border-gray-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.hover\\:border-gray-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.hover\\:border-gray-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.hover\\:border-gray-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.hover\\:border-gray-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.hover\\:border-gray-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity));
}
.hover\\:border-green-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity));
}
.hover\\:border-green-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.hover\\:border-green-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.hover\\:border-green-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.hover\\:border-green-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 244 / var(--tw-border-opacity));
}
.hover\\:border-green-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.hover\\:border-green-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
.hover\\:border-green-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.hover\\:border-green-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity));
}
.hover\\:border-green-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(20 83 45 / var(--tw-border-opacity));
}
.hover\\:border-green-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(5 46 22 / var(--tw-border-opacity));
}
.hover\\:border-indigo-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
.hover\\:border-indigo-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
.hover\\:border-indigo-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
.hover\\:border-indigo-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
}
.hover\\:border-indigo-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity));
}
.hover\\:border-indigo-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.hover\\:border-indigo-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
.hover\\:border-indigo-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity));
}
.hover\\:border-indigo-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity));
}
.hover\\:border-indigo-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity));
}
.hover\\:border-indigo-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(30 27 75 / var(--tw-border-opacity));
}
.hover\\:border-lime-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / var(--tw-border-opacity));
}
.hover\\:border-lime-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity));
}
.hover\\:border-lime-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity));
}
.hover\\:border-lime-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity));
}
.hover\\:border-lime-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(247 254 231 / var(--tw-border-opacity));
}
.hover\\:border-lime-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
.hover\\:border-lime-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity));
}
.hover\\:border-lime-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity));
}
.hover\\:border-lime-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / var(--tw-border-opacity));
}
.hover\\:border-lime-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(54 83 20 / var(--tw-border-opacity));
}
.hover\\:border-lime-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(26 46 5 / var(--tw-border-opacity));
}
.hover\\:border-neutral-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.hover\\:border-neutral-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity));
}
.hover\\:border-neutral-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
.hover\\:border-neutral-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(163 163 163 / var(--tw-border-opacity));
}
.hover\\:border-neutral-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.hover\\:border-neutral-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(115 115 115 / var(--tw-border-opacity));
}
.hover\\:border-neutral-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity));
}
.hover\\:border-neutral-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}
.hover\\:border-neutral-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / var(--tw-border-opacity));
}
.hover\\:border-neutral-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(23 23 23 / var(--tw-border-opacity));
}
.hover\\:border-neutral-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(10 10 10 / var(--tw-border-opacity));
}
.hover\\:border-orange-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity));
}
.hover\\:border-orange-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
.hover\\:border-orange-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
.hover\\:border-orange-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
.hover\\:border-orange-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 247 237 / var(--tw-border-opacity));
}
.hover\\:border-orange-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.hover\\:border-orange-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity));
}
.hover\\:border-orange-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity));
}
.hover\\:border-orange-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity));
}
.hover\\:border-orange-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / var(--tw-border-opacity));
}
.hover\\:border-orange-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(67 20 7 / var(--tw-border-opacity));
}
.hover\\:border-pink-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity));
}
.hover\\:border-pink-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity));
}
.hover\\:border-pink-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity));
}
.hover\\:border-pink-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity));
}
.hover\\:border-pink-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 242 248 / var(--tw-border-opacity));
}
.hover\\:border-pink-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.hover\\:border-pink-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity));
}
.hover\\:border-pink-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity));
}
.hover\\:border-pink-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity));
}
.hover\\:border-pink-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(131 24 67 / var(--tw-border-opacity));
}
.hover\\:border-pink-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(80 7 36 / var(--tw-border-opacity));
}
.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
.hover\\:border-purple-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity));
}
.hover\\:border-purple-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
.hover\\:border-purple-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity));
}
.hover\\:border-purple-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity));
}
.hover\\:border-purple-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 245 255 / var(--tw-border-opacity));
}
.hover\\:border-purple-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}
.hover\\:border-purple-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity));
}
.hover\\:border-purple-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity));
}
.hover\\:border-purple-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity));
}
.hover\\:border-purple-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(88 28 135 / var(--tw-border-opacity));
}
.hover\\:border-purple-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(59 7 100 / var(--tw-border-opacity));
}
.hover\\:border-red-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity));
}
.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.hover\\:border-red-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.hover\\:border-red-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.hover\\:border-red-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / var(--tw-border-opacity));
}
.hover\\:border-red-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.hover\\:border-red-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.hover\\:border-red-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.hover\\:border-red-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity));
}
.hover\\:border-red-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity));
}
.hover\\:border-red-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(69 10 10 / var(--tw-border-opacity));
}
.hover\\:border-rose-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity));
}
.hover\\:border-rose-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
.hover\\:border-rose-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
.hover\\:border-rose-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity));
}
.hover\\:border-rose-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 241 242 / var(--tw-border-opacity));
}
.hover\\:border-rose-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.hover\\:border-rose-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity));
}
.hover\\:border-rose-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity));
}
.hover\\:border-rose-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity));
}
.hover\\:border-rose-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / var(--tw-border-opacity));
}
.hover\\:border-rose-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(76 5 25 / var(--tw-border-opacity));
}
.hover\\:border-secondary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 75 141 / var(--tw-border-opacity));
}
.hover\\:border-sky-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity));
}
.hover\\:border-sky-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity));
}
.hover\\:border-sky-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
.hover\\:border-sky-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity));
}
.hover\\:border-sky-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / var(--tw-border-opacity));
}
.hover\\:border-sky-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.hover\\:border-sky-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity));
}
.hover\\:border-sky-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(3 105 161 / var(--tw-border-opacity));
}
.hover\\:border-sky-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity));
}
.hover\\:border-sky-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(12 74 110 / var(--tw-border-opacity));
}
.hover\\:border-sky-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(8 47 73 / var(--tw-border-opacity));
}
.hover\\:border-slate-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity));
}
.hover\\:border-slate-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.hover\\:border-slate-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity));
}
.hover\\:border-slate-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
.hover\\:border-slate-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.hover\\:border-slate-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity));
}
.hover\\:border-slate-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.hover\\:border-slate-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity));
}
.hover\\:border-slate-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}
.hover\\:border-slate-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(2 6 23 / var(--tw-border-opacity));
}
.hover\\:border-stone-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-border-opacity));
}
.hover\\:border-stone-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity));
}
.hover\\:border-stone-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
.hover\\:border-stone-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity));
}
.hover\\:border-stone-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / var(--tw-border-opacity));
}
.hover\\:border-stone-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(120 113 108 / var(--tw-border-opacity));
}
.hover\\:border-stone-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity));
}
.hover\\:border-stone-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity));
}
.hover\\:border-stone-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / var(--tw-border-opacity));
}
.hover\\:border-stone-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / var(--tw-border-opacity));
}
.hover\\:border-stone-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(12 10 9 / var(--tw-border-opacity));
}
.hover\\:border-teal-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity));
}
.hover\\:border-teal-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity));
}
.hover\\:border-teal-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
.hover\\:border-teal-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity));
}
.hover\\:border-teal-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 250 / var(--tw-border-opacity));
}
.hover\\:border-teal-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
.hover\\:border-teal-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity));
}
.hover\\:border-teal-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity));
}
.hover\\:border-teal-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity));
}
.hover\\:border-teal-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(19 78 74 / var(--tw-border-opacity));
}
.hover\\:border-teal-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(4 47 46 / var(--tw-border-opacity));
}
.hover\\:border-transparent:hover {
  border-color: transparent;
}
.hover\\:border-tremor-brand-emphasis:hover {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.hover\\:border-tremor-content:hover {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.hover\\:border-violet-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity));
}
.hover\\:border-violet-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
.hover\\:border-violet-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
.hover\\:border-violet-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity));
}
.hover\\:border-violet-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(245 243 255 / var(--tw-border-opacity));
}
.hover\\:border-violet-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.hover\\:border-violet-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity));
}
.hover\\:border-violet-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity));
}
.hover\\:border-violet-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity));
}
.hover\\:border-violet-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(76 29 149 / var(--tw-border-opacity));
}
.hover\\:border-violet-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(46 16 101 / var(--tw-border-opacity));
}
.hover\\:border-yellow-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity));
}
.hover\\:border-yellow-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
.hover\\:border-yellow-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
.hover\\:border-yellow-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}
.hover\\:border-yellow-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 252 232 / var(--tw-border-opacity));
}
.hover\\:border-yellow-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
.hover\\:border-yellow-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
}
.hover\\:border-yellow-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / var(--tw-border-opacity));
}
.hover\\:border-yellow-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity));
}
.hover\\:border-yellow-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(113 63 18 / var(--tw-border-opacity));
}
.hover\\:border-yellow-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(66 32 6 / var(--tw-border-opacity));
}
.hover\\:border-zinc-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity));
}
.hover\\:border-zinc-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}
.hover\\:border-zinc-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.hover\\:border-zinc-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity));
}
.hover\\:border-zinc-50:hover {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.hover\\:border-zinc-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity));
}
.hover\\:border-zinc-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity));
}
.hover\\:border-zinc-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.hover\\:border-zinc-800:hover {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.hover\\:border-zinc-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity));
}
.hover\\:border-zinc-950:hover {
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity));
}
.hover\\:\\!bg-blue-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity)) !important;
}
.hover\\:bg-\\[\\#e20221\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#f3f4f6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-\\[\\#ffcc33\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 51 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity));
}
.hover\\:bg-amber-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity));
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-300\\/20:hover {
  background-color: rgb(147 197 253 / 0.2);
}
.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}
.hover\\:bg-cyan-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 51 68 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}
.hover\\:bg-emerald-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / var(--tw-bg-opacity));
}
.hover\\:bg-fuchsia-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(74 4 78 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-300\\/20:hover {
  background-color: rgb(209 213 219 / 0.2);
}
.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-light:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity));
}
.hover\\:bg-green-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.hover\\:bg-green-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}
.hover\\:bg-green-300\\/20:hover {
  background-color: rgb(134 239 172 / 0.2);
}
.hover\\:bg-green-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.hover\\:bg-green-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.hover\\:bg-green-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity));
}
.hover\\:bg-green-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
.hover\\:bg-green-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / var(--tw-bg-opacity));
}
.hover\\:bg-lime-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 46 5 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}
.hover\\:bg-neutral-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-300\\/20:hover {
  background-color: rgb(253 186 116 / 0.2);
}
.hover\\:bg-orange-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 20 7 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(80 7 36 / var(--tw-bg-opacity));
}
.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-300\\/20:hover {
  background-color: rgb(216 180 254 / 0.2);
}
.hover\\:bg-purple-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
.hover\\:bg-red-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}
.hover\\:bg-red-300\\/20:hover {
  background-color: rgb(252 165 165 / 0.2);
}
.hover\\:bg-red-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.hover\\:bg-red-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.hover\\:bg-red-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity));
}
.hover\\:bg-red-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / var(--tw-bg-opacity));
}
.hover\\:bg-rose-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(76 5 25 / var(--tw-bg-opacity));
}
.hover\\:bg-secondary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 75 141 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / var(--tw-bg-opacity));
}
.hover\\:bg-sky-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.hover\\:bg-slate-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity));
}
.hover\\:bg-stone-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 47 46 / var(--tw-bg-opacity));
}
.hover\\:bg-tremor-background-muted:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.hover\\:bg-tremor-background-subtle:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.hover\\:bg-tremor-brand-emphasis:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.hover\\:bg-tremor-brand-faint:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / var(--tw-bg-opacity));
}
.hover\\:bg-violet-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/30:hover {
  background-color: rgb(255 255 255 / 0.3);
}
.hover\\:bg-yellow-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}
.hover\\:bg-yellow-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(66 32 6 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.hover\\:bg-zinc-950:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity));
}
.hover\\:bg-opacity-20:hover {
  --tw-bg-opacity: 0.2;
}
.hover\\:bg-opacity-50:hover {
  --tw-bg-opacity: 0.5;
}
.hover\\:text-\\[\\#e20221\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.hover\\:text-\\[\\#ffcc33\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 204 51 / var(--tw-text-opacity));
}
.hover\\:text-amber-100:hover {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity));
}
.hover\\:text-amber-200:hover {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}
.hover\\:text-amber-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.hover\\:text-amber-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.hover\\:text-amber-50:hover {
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity));
}
.hover\\:text-amber-500:hover {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.hover\\:text-amber-600:hover {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.hover\\:text-amber-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.hover\\:text-amber-800:hover {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
.hover\\:text-amber-900:hover {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.hover\\:text-amber-950:hover {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity));
}
.hover\\:text-blue-100:hover {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity));
}
.hover\\:text-blue-200:hover {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity));
}
.hover\\:text-blue-300:hover {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.hover\\:text-blue-50:hover {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity));
}
.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.hover\\:text-blue-950:hover {
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity));
}
.hover\\:text-cyan-100:hover {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity));
}
.hover\\:text-cyan-200:hover {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity));
}
.hover\\:text-cyan-300:hover {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
.hover\\:text-cyan-400:hover {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity));
}
.hover\\:text-cyan-50:hover {
  --tw-text-opacity: 1;
  color: rgb(236 254 255 / var(--tw-text-opacity));
}
.hover\\:text-cyan-500:hover {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
.hover\\:text-cyan-600:hover {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
.hover\\:text-cyan-800:hover {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
.hover\\:text-cyan-900:hover {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}
.hover\\:text-cyan-950:hover {
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity));
}
.hover\\:text-emerald-100:hover {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity));
}
.hover\\:text-emerald-200:hover {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity));
}
.hover\\:text-emerald-300:hover {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.hover\\:text-emerald-400:hover {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.hover\\:text-emerald-50:hover {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}
.hover\\:text-emerald-500:hover {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.hover\\:text-emerald-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity));
}
.hover\\:text-emerald-900:hover {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
.hover\\:text-emerald-950:hover {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-100:hover {
  --tw-text-opacity: 1;
  color: rgb(250 232 255 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-200:hover {
  --tw-text-opacity: 1;
  color: rgb(245 208 254 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-300:hover {
  --tw-text-opacity: 1;
  color: rgb(240 171 252 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-400:hover {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-50:hover {
  --tw-text-opacity: 1;
  color: rgb(253 244 255 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-500:hover {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-600:hover {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-700:hover {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-800:hover {
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-900:hover {
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / var(--tw-text-opacity));
}
.hover\\:text-fuchsia-950:hover {
  --tw-text-opacity: 1;
  color: rgb(74 4 78 / var(--tw-text-opacity));
}
.hover\\:text-gray-100:hover {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.hover\\:text-gray-400:hover {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.hover\\:text-gray-50:hover {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.hover\\:text-gray-950:hover {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity));
}
.hover\\:text-green-100:hover {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity));
}
.hover\\:text-green-200:hover {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity));
}
.hover\\:text-green-300:hover {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}
.hover\\:text-green-400:hover {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
.hover\\:text-green-50:hover {
  --tw-text-opacity: 1;
  color: rgb(240 253 244 / var(--tw-text-opacity));
}
.hover\\:text-green-500:hover {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.hover\\:text-green-600:hover {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.hover\\:text-green-800:hover {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.hover\\:text-green-900:hover {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
.hover\\:text-green-950:hover {
  --tw-text-opacity: 1;
  color: rgb(5 46 22 / var(--tw-text-opacity));
}
.hover\\:text-indigo-100:hover {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity));
}
.hover\\:text-indigo-200:hover {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity));
}
.hover\\:text-indigo-300:hover {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
.hover\\:text-indigo-400:hover {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}
.hover\\:text-indigo-50:hover {
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / var(--tw-text-opacity));
}
.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.hover\\:text-indigo-900:hover {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity));
}
.hover\\:text-indigo-950:hover {
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity));
}
.hover\\:text-lime-100:hover {
  --tw-text-opacity: 1;
  color: rgb(236 252 203 / var(--tw-text-opacity));
}
.hover\\:text-lime-200:hover {
  --tw-text-opacity: 1;
  color: rgb(217 249 157 / var(--tw-text-opacity));
}
.hover\\:text-lime-300:hover {
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / var(--tw-text-opacity));
}
.hover\\:text-lime-400:hover {
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / var(--tw-text-opacity));
}
.hover\\:text-lime-50:hover {
  --tw-text-opacity: 1;
  color: rgb(247 254 231 / var(--tw-text-opacity));
}
.hover\\:text-lime-500:hover {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.hover\\:text-lime-600:hover {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}
.hover\\:text-lime-700:hover {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
.hover\\:text-lime-800:hover {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}
.hover\\:text-lime-900:hover {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}
.hover\\:text-lime-950:hover {
  --tw-text-opacity: 1;
  color: rgb(26 46 5 / var(--tw-text-opacity));
}
.hover\\:text-neutral-100:hover {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.hover\\:text-neutral-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}
.hover\\:text-neutral-300:hover {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}
.hover\\:text-neutral-400:hover {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
.hover\\:text-neutral-50:hover {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.hover\\:text-neutral-500:hover {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.hover\\:text-neutral-600:hover {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}
.hover\\:text-neutral-700:hover {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
.hover\\:text-neutral-800:hover {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity));
}
.hover\\:text-neutral-900:hover {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity));
}
.hover\\:text-neutral-950:hover {
  --tw-text-opacity: 1;
  color: rgb(10 10 10 / var(--tw-text-opacity));
}
.hover\\:text-orange-100:hover {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity));
}
.hover\\:text-orange-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity));
}
.hover\\:text-orange-300:hover {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}
.hover\\:text-orange-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
.hover\\:text-orange-50:hover {
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / var(--tw-text-opacity));
}
.hover\\:text-orange-500:hover {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.hover\\:text-orange-600:hover {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.hover\\:text-orange-700:hover {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.hover\\:text-orange-800:hover {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
.hover\\:text-orange-900:hover {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity));
}
.hover\\:text-orange-950:hover {
  --tw-text-opacity: 1;
  color: rgb(67 20 7 / var(--tw-text-opacity));
}
.hover\\:text-pink-100:hover {
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity));
}
.hover\\:text-pink-200:hover {
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity));
}
.hover\\:text-pink-300:hover {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity));
}
.hover\\:text-pink-400:hover {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity));
}
.hover\\:text-pink-50:hover {
  --tw-text-opacity: 1;
  color: rgb(253 242 248 / var(--tw-text-opacity));
}
.hover\\:text-pink-500:hover {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
.hover\\:text-pink-600:hover {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.hover\\:text-pink-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
.hover\\:text-pink-800:hover {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity));
}
.hover\\:text-pink-900:hover {
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity));
}
.hover\\:text-pink-950:hover {
  --tw-text-opacity: 1;
  color: rgb(80 7 36 / var(--tw-text-opacity));
}
.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.hover\\:text-purple-100:hover {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity));
}
.hover\\:text-purple-200:hover {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity));
}
.hover\\:text-purple-300:hover {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}
.hover\\:text-purple-400:hover {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity));
}
.hover\\:text-purple-50:hover {
  --tw-text-opacity: 1;
  color: rgb(250 245 255 / var(--tw-text-opacity));
}
.hover\\:text-purple-500:hover {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.hover\\:text-purple-600:hover {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.hover\\:text-purple-700:hover {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity));
}
.hover\\:text-purple-950:hover {
  --tw-text-opacity: 1;
  color: rgb(59 7 100 / var(--tw-text-opacity));
}
.hover\\:text-red-100:hover {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity));
}
.hover\\:text-red-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}
.hover\\:text-red-300:hover {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.hover\\:text-red-950:hover {
  --tw-text-opacity: 1;
  color: rgb(69 10 10 / var(--tw-text-opacity));
}
.hover\\:text-rose-100:hover {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity));
}
.hover\\:text-rose-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity));
}
.hover\\:text-rose-300:hover {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity));
}
.hover\\:text-rose-400:hover {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
.hover\\:text-rose-50:hover {
  --tw-text-opacity: 1;
  color: rgb(255 241 242 / var(--tw-text-opacity));
}
.hover\\:text-rose-500:hover {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.hover\\:text-rose-600:hover {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.hover\\:text-rose-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
.hover\\:text-rose-800:hover {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity));
}
.hover\\:text-rose-900:hover {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity));
}
.hover\\:text-rose-950:hover {
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity));
}
.hover\\:text-secondary:hover {
  --tw-text-opacity: 1;
  color: rgb(0 75 141 / var(--tw-text-opacity));
}
.hover\\:text-sky-100:hover {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity));
}
.hover\\:text-sky-200:hover {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity));
}
.hover\\:text-sky-300:hover {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
.hover\\:text-sky-400:hover {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity));
}
.hover\\:text-sky-50:hover {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity));
}
.hover\\:text-sky-500:hover {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
.hover\\:text-sky-600:hover {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.hover\\:text-sky-700:hover {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
.hover\\:text-sky-800:hover {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity));
}
.hover\\:text-sky-900:hover {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity));
}
.hover\\:text-sky-950:hover {
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity));
}
.hover\\:text-slate-100:hover {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity));
}
.hover\\:text-slate-200:hover {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.hover\\:text-slate-300:hover {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.hover\\:text-slate-400:hover {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.hover\\:text-slate-50:hover {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}
.hover\\:text-slate-500:hover {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.hover\\:text-slate-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.hover\\:text-slate-950:hover {
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity));
}
.hover\\:text-stone-100:hover {
  --tw-text-opacity: 1;
  color: rgb(245 245 244 / var(--tw-text-opacity));
}
.hover\\:text-stone-200:hover {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
.hover\\:text-stone-300:hover {
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity));
}
.hover\\:text-stone-400:hover {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity));
}
.hover\\:text-stone-50:hover {
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / var(--tw-text-opacity));
}
.hover\\:text-stone-500:hover {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity));
}
.hover\\:text-stone-600:hover {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity));
}
.hover\\:text-stone-700:hover {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity));
}
.hover\\:text-stone-800:hover {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity));
}
.hover\\:text-stone-900:hover {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity));
}
.hover\\:text-stone-950:hover {
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity));
}
.hover\\:text-teal-100:hover {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity));
}
.hover\\:text-teal-200:hover {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity));
}
.hover\\:text-teal-300:hover {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity));
}
.hover\\:text-teal-400:hover {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity));
}
.hover\\:text-teal-50:hover {
  --tw-text-opacity: 1;
  color: rgb(240 253 250 / var(--tw-text-opacity));
}
.hover\\:text-teal-500:hover {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity));
}
.hover\\:text-teal-600:hover {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
.hover\\:text-teal-700:hover {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity));
}
.hover\\:text-teal-800:hover {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity));
}
.hover\\:text-teal-900:hover {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity));
}
.hover\\:text-teal-950:hover {
  --tw-text-opacity: 1;
  color: rgb(4 47 46 / var(--tw-text-opacity));
}
.hover\\:text-tremor-brand-emphasis:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.hover\\:text-tremor-content:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.hover\\:text-tremor-content-emphasis:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.hover\\:text-violet-100:hover {
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity));
}
.hover\\:text-violet-200:hover {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity));
}
.hover\\:text-violet-300:hover {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity));
}
.hover\\:text-violet-400:hover {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity));
}
.hover\\:text-violet-50:hover {
  --tw-text-opacity: 1;
  color: rgb(245 243 255 / var(--tw-text-opacity));
}
.hover\\:text-violet-500:hover {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
.hover\\:text-violet-600:hover {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.hover\\:text-violet-700:hover {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
.hover\\:text-violet-800:hover {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity));
}
.hover\\:text-violet-900:hover {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity));
}
.hover\\:text-violet-950:hover {
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.hover\\:text-yellow-100:hover {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity));
}
.hover\\:text-yellow-200:hover {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity));
}
.hover\\:text-yellow-300:hover {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}
.hover\\:text-yellow-400:hover {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}
.hover\\:text-yellow-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 252 232 / var(--tw-text-opacity));
}
.hover\\:text-yellow-500:hover {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.hover\\:text-yellow-600:hover {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.hover\\:text-yellow-700:hover {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.hover\\:text-yellow-800:hover {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.hover\\:text-yellow-900:hover {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity));
}
.hover\\:text-yellow-950:hover {
  --tw-text-opacity: 1;
  color: rgb(66 32 6 / var(--tw-text-opacity));
}
.hover\\:text-zinc-100:hover {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
.hover\\:text-zinc-200:hover {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}
.hover\\:text-zinc-300:hover {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity));
}
.hover\\:text-zinc-400:hover {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.hover\\:text-zinc-50:hover {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.hover\\:text-zinc-500:hover {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.hover\\:text-zinc-600:hover {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.hover\\:text-zinc-700:hover {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
.hover\\:text-zinc-800:hover {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity));
}
.hover\\:text-zinc-900:hover {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity));
}
.hover\\:text-zinc-950:hover {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:transition-opacity:hover {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.hover\\:duration-300:hover {
  transition-duration: 300ms;
}
.focus\\:border-blue-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.focus\\:border-tremor-brand-subtle:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.focus\\:focus\\:shadow-\\[inset_0_0_0_0\\.2rem_rgba\\(191\\2c 219\\2c 254\\2c 1\\)\\]:focus:focus {
  --tw-shadow: inset 0 0 0 0.2rem rgba(191,219,254,1);
  --tw-shadow-colored: inset 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_0\\.2rem_rgba\\(191\\2c 219\\2c 254\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 0.2rem rgba(191,219,254,1);
  --tw-shadow-colored: 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(136\\2c 234\\2c 172\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(136,234,172,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(157\\2c 193\\2c 251\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(157,193,251,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(176\\2c 185\\2c 198\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(176,185,198,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(212\\2c 170\\2c 251\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(212,170,251,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(247\\2c 162\\2c 162\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(247,162,162,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[0_0_0_2px_rgba\\(255\\2c 255\\2c 255\\2c 1\\)\\2c 0_0_0_4px_rgba\\(250\\2c 207\\2c 133\\2c 1\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 1\\)\\]:focus {
  --tw-shadow: 0 0 0 2px rgba(255,255,255,1),0 0 0 4px rgba(250,207,133,1),0 1px 2px 0 rgba(0,0,0,1);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-\\[inset_0_0_0_0\\.2rem_rgba\\(191\\2c 219\\2c 254\\2c 1\\)\\]:focus {
  --tw-shadow: inset 0 0 0 0.2rem rgba(191,219,254,1);
  --tw-shadow-colored: inset 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline:focus {
  outline-style: solid;
}
.focus\\:outline-0:focus {
  outline-width: 0px;
}
.focus\\:outline-\\[0\\.15rem\\]:focus {
  outline-width: 0.15rem;
}
.focus\\:outline-offset-0:focus {
  outline-offset: 0px;
}
.focus\\:outline-offset-\\[-0\\.15rem\\]:focus {
  outline-offset: -0.15rem;
}
.focus\\:outline-blue-200:focus {
  outline-color: #bfdbfe;
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-transparent:focus {
  --tw-ring-color: transparent;
}
.focus\\:ring-tremor-brand-muted:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity));
}
.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px;
}
.active\\:border-secondary:active {
  --tw-border-opacity: 1;
  border-color: rgb(0 75 141 / var(--tw-border-opacity));
}
.active\\:bg-secondary:active {
  --tw-bg-opacity: 1;
  background-color: rgb(0 75 141 / var(--tw-bg-opacity));
}
.active\\:text-white:active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.disabled\\:border-secondary:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(0 75 141 / var(--tw-border-opacity));
}
.disabled\\:bg-secondary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(0 75 141 / var(--tw-bg-opacity));
}
.disabled\\:bg-white:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.disabled\\:text-white:disabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}
.hover\\:disabled\\:text-primary:disabled:hover {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.group:hover .group-hover\\:text-tremor-content-emphasis {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.group:active .group-active\\:scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.aria-selected\\:\\!bg-tremor-background-subtle[aria-selected="true"] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity)) !important;
}
.aria-selected\\:bg-tremor-background-emphasis[aria-selected="true"] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.aria-selected\\:\\!text-tremor-content[aria-selected="true"] {
  --tw-text-opacity: 1 !important;
  color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}
.aria-selected\\:text-tremor-brand-inverted[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.aria-selected\\:text-tremor-content-inverted[aria-selected="true"] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.ui-selected\\:border-b-2[data-headlessui-state~="selected"] {
  border-bottom-width: 2px;
}
.ui-selected\\:border-\\[\\#e20221\\][data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
.ui-selected\\:border-\\[\\#ffcc33\\][data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 204 51 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 251 235 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity));
}
.ui-selected\\:border-amber-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(69 26 3 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
.ui-selected\\:border-blue-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(23 37 84 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(236 254 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / var(--tw-border-opacity));
}
.ui-selected\\:border-cyan-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(8 51 68 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity));
}
.ui-selected\\:border-emerald-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(2 44 34 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 232 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(240 171 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 244 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(192 38 211 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(162 28 175 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / var(--tw-border-opacity));
}
.ui-selected\\:border-fuchsia-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(74 4 78 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.ui-selected\\:border-gray-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 244 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(20 83 45 / var(--tw-border-opacity));
}
.ui-selected\\:border-green-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(5 46 22 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity));
}
.ui-selected\\:border-indigo-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(30 27 75 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(247 254 231 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(54 83 20 / var(--tw-border-opacity));
}
.ui-selected\\:border-lime-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(26 46 5 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(163 163 163 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(115 115 115 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(23 23 23 / var(--tw-border-opacity));
}
.ui-selected\\:border-neutral-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(10 10 10 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 247 237 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / var(--tw-border-opacity));
}
.ui-selected\\:border-orange-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(67 20 7 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 242 248 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(131 24 67 / var(--tw-border-opacity));
}
.ui-selected\\:border-pink-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(80 7 36 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 245 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(88 28 135 / var(--tw-border-opacity));
}
.ui-selected\\:border-purple-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(59 7 100 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity));
}
.ui-selected\\:border-red-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(69 10 10 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(255 241 242 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / var(--tw-border-opacity));
}
.ui-selected\\:border-rose-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(76 5 25 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(3 105 161 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(12 74 110 / var(--tw-border-opacity));
}
.ui-selected\\:border-sky-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(8 47 73 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}
.ui-selected\\:border-slate-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(2 6 23 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(120 113 108 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / var(--tw-border-opacity));
}
.ui-selected\\:border-stone-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(12 10 9 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 250 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(19 78 74 / var(--tw-border-opacity));
}
.ui-selected\\:border-teal-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(4 47 46 / var(--tw-border-opacity));
}
.ui-selected\\:border-tremor-border[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.ui-selected\\:border-tremor-brand[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(245 243 255 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(76 29 149 / var(--tw-border-opacity));
}
.ui-selected\\:border-violet-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(46 16 101 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(254 252 232 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(113 63 18 / var(--tw-border-opacity));
}
.ui-selected\\:border-yellow-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(66 32 6 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-100[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-200[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-300[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-400[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-50[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-500[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-600[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-700[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-800[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-900[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity));
}
.ui-selected\\:border-zinc-950[data-headlessui-state~="selected"] {
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity));
}
.ui-selected\\:bg-\\[\\#e20221\\][data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-\\[\\#ffcc33\\][data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 51 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-amber-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-blue-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-cyan-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 51 68 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-emerald-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-fuchsia-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(74 4 78 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-gray-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-green-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-indigo-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-lime-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 46 5 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-neutral-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-orange-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(67 20 7 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-pink-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(80 7 36 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-purple-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-red-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-rose-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(76 5 25 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-sky-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-slate-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-stone-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-teal-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 47 46 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-tremor-background[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-tremor-background-muted[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-violet-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-yellow-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(66 32 6 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-100[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-200[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-300[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-400[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-50[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-500[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-600[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-700[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-800[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-900[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.ui-selected\\:bg-zinc-950[data-headlessui-state~="selected"] {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity));
}
.ui-selected\\:text-\\[\\#e20221\\][data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
.ui-selected\\:text-\\[\\#ffcc33\\][data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 204 51 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
.ui-selected\\:text-amber-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.ui-selected\\:text-blue-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(236 254 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}
.ui-selected\\:text-cyan-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
.ui-selected\\:text-emerald-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 232 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(245 208 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(240 171 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 244 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / var(--tw-text-opacity));
}
.ui-selected\\:text-fuchsia-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(74 4 78 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.ui-selected\\:text-gray-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(240 253 244 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
.ui-selected\\:text-green-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(5 46 22 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity));
}
.ui-selected\\:text-indigo-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(236 252 203 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(217 249 157 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(247 254 231 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}
.ui-selected\\:text-lime-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(26 46 5 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity));
}
.ui-selected\\:text-neutral-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(10 10 10 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity));
}
.ui-selected\\:text-orange-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(67 20 7 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 242 248 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity));
}
.ui-selected\\:text-pink-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(80 7 36 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 245 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity));
}
.ui-selected\\:text-purple-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(59 7 100 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
.ui-selected\\:text-red-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(69 10 10 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(255 241 242 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity));
}
.ui-selected\\:text-rose-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity));
}
.ui-selected\\:text-sky-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
.ui-selected\\:text-slate-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(245 245 244 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity));
}
.ui-selected\\:text-stone-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(240 253 250 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity));
}
.ui-selected\\:text-teal-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(4 47 46 / var(--tw-text-opacity));
}
.ui-selected\\:text-tremor-brand[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.ui-selected\\:text-tremor-content-emphasis[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.ui-selected\\:text-tremor-content-strong[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(245 243 255 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity));
}
.ui-selected\\:text-violet-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(254 252 232 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity));
}
.ui-selected\\:text-yellow-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(66 32 6 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-100[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-200[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-300[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-400[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-50[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-500[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-600[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-700[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-800[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-900[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity));
}
.ui-selected\\:text-zinc-950[data-headlessui-state~="selected"] {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity));
}
.ui-selected\\:shadow-tremor-input[data-headlessui-state~="selected"] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-b-2 {
  border-bottom-width: 2px;
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-\\[\\#e20221\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 2 33 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-\\[\\#ffcc33\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 204 51 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 251 235 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-600 {
  --tw-border-opacity: 1;
  border-color: rgb(217 119 6 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-700 {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-800 {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-900 {
  --tw-border-opacity: 1;
  border-color: rgb(120 53 15 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-amber-950 {
  --tw-border-opacity: 1;
  border-color: rgb(69 26 3 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-50 {
  --tw-border-opacity: 1;
  border-color: rgb(239 246 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-700 {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-blue-950 {
  --tw-border-opacity: 1;
  border-color: rgb(23 37 84 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-200 {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-400 {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 254 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-700 {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-800 {
  --tw-border-opacity: 1;
  border-color: rgb(21 94 117 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-900 {
  --tw-border-opacity: 1;
  border-color: rgb(22 78 99 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-cyan-950 {
  --tw-border-opacity: 1;
  border-color: rgb(8 51 68 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 253 245 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 120 87 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-800 {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-900 {
  --tw-border-opacity: 1;
  border-color: rgb(6 78 59 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-emerald-950 {
  --tw-border-opacity: 1;
  border-color: rgb(2 44 34 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-100 {
  --tw-border-opacity: 1;
  border-color: rgb(250 232 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-200 {
  --tw-border-opacity: 1;
  border-color: rgb(245 208 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-300 {
  --tw-border-opacity: 1;
  border-color: rgb(240 171 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-400 {
  --tw-border-opacity: 1;
  border-color: rgb(232 121 249 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-50 {
  --tw-border-opacity: 1;
  border-color: rgb(253 244 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-500 {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-600 {
  --tw-border-opacity: 1;
  border-color: rgb(192 38 211 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-700 {
  --tw-border-opacity: 1;
  border-color: rgb(162 28 175 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-800 {
  --tw-border-opacity: 1;
  border-color: rgb(134 25 143 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-900 {
  --tw-border-opacity: 1;
  border-color: rgb(112 26 117 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-fuchsia-950 {
  --tw-border-opacity: 1;
  border-color: rgb(74 4 78 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-gray-950 {
  --tw-border-opacity: 1;
  border-color: rgb(3 7 18 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 244 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-800 {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-900 {
  --tw-border-opacity: 1;
  border-color: rgb(20 83 45 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-green-950 {
  --tw-border-opacity: 1;
  border-color: rgb(5 46 22 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-50 {
  --tw-border-opacity: 1;
  border-color: rgb(238 242 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-600 {
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-700 {
  --tw-border-opacity: 1;
  border-color: rgb(67 56 202 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-800 {
  --tw-border-opacity: 1;
  border-color: rgb(55 48 163 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-900 {
  --tw-border-opacity: 1;
  border-color: rgb(49 46 129 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-indigo-950 {
  --tw-border-opacity: 1;
  border-color: rgb(30 27 75 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-100 {
  --tw-border-opacity: 1;
  border-color: rgb(236 252 203 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-200 {
  --tw-border-opacity: 1;
  border-color: rgb(217 249 157 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-300 {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-50 {
  --tw-border-opacity: 1;
  border-color: rgb(247 254 231 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-600 {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-700 {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-800 {
  --tw-border-opacity: 1;
  border-color: rgb(63 98 18 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-900 {
  --tw-border-opacity: 1;
  border-color: rgb(54 83 20 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-lime-950 {
  --tw-border-opacity: 1;
  border-color: rgb(26 46 5 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 245 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 212 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 163 163 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-500 {
  --tw-border-opacity: 1;
  border-color: rgb(115 115 115 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 82 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-700 {
  --tw-border-opacity: 1;
  border-color: rgb(64 64 64 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-800 {
  --tw-border-opacity: 1;
  border-color: rgb(38 38 38 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-900 {
  --tw-border-opacity: 1;
  border-color: rgb(23 23 23 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-neutral-950 {
  --tw-border-opacity: 1;
  border-color: rgb(10 10 10 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 186 116 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 247 237 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-600 {
  --tw-border-opacity: 1;
  border-color: rgb(234 88 12 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-700 {
  --tw-border-opacity: 1;
  border-color: rgb(194 65 12 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-800 {
  --tw-border-opacity: 1;
  border-color: rgb(154 52 18 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-900 {
  --tw-border-opacity: 1;
  border-color: rgb(124 45 18 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-orange-950 {
  --tw-border-opacity: 1;
  border-color: rgb(67 20 7 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-100 {
  --tw-border-opacity: 1;
  border-color: rgb(252 231 243 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-400 {
  --tw-border-opacity: 1;
  border-color: rgb(244 114 182 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-50 {
  --tw-border-opacity: 1;
  border-color: rgb(253 242 248 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-600 {
  --tw-border-opacity: 1;
  border-color: rgb(219 39 119 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-700 {
  --tw-border-opacity: 1;
  border-color: rgb(190 24 93 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-800 {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-900 {
  --tw-border-opacity: 1;
  border-color: rgb(131 24 67 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-pink-950 {
  --tw-border-opacity: 1;
  border-color: rgb(80 7 36 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-300 {
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-400 {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 245 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-600 {
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-700 {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-800 {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(88 28 135 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-purple-950 {
  --tw-border-opacity: 1;
  border-color: rgb(59 7 100 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 242 242 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(220 38 38 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-800 {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-900 {
  --tw-border-opacity: 1;
  border-color: rgb(127 29 29 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-red-950 {
  --tw-border-opacity: 1;
  border-color: rgb(69 10 10 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-400 {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-50 {
  --tw-border-opacity: 1;
  border-color: rgb(255 241 242 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-600 {
  --tw-border-opacity: 1;
  border-color: rgb(225 29 72 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-700 {
  --tw-border-opacity: 1;
  border-color: rgb(190 18 60 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-800 {
  --tw-border-opacity: 1;
  border-color: rgb(159 18 57 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-900 {
  --tw-border-opacity: 1;
  border-color: rgb(136 19 55 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-rose-950 {
  --tw-border-opacity: 1;
  border-color: rgb(76 5 25 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 242 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-200 {
  --tw-border-opacity: 1;
  border-color: rgb(186 230 253 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-300 {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-400 {
  --tw-border-opacity: 1;
  border-color: rgb(56 189 248 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 249 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-600 {
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-700 {
  --tw-border-opacity: 1;
  border-color: rgb(3 105 161 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-800 {
  --tw-border-opacity: 1;
  border-color: rgb(7 89 133 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-900 {
  --tw-border-opacity: 1;
  border-color: rgb(12 74 110 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-sky-950 {
  --tw-border-opacity: 1;
  border-color: rgb(8 47 73 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-900 {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-slate-950 {
  --tw-border-opacity: 1;
  border-color: rgb(2 6 23 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-100 {
  --tw-border-opacity: 1;
  border-color: rgb(245 245 244 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-200 {
  --tw-border-opacity: 1;
  border-color: rgb(231 229 228 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-300 {
  --tw-border-opacity: 1;
  border-color: rgb(214 211 209 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-400 {
  --tw-border-opacity: 1;
  border-color: rgb(168 162 158 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 249 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-500 {
  --tw-border-opacity: 1;
  border-color: rgb(120 113 108 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-600 {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-700 {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-800 {
  --tw-border-opacity: 1;
  border-color: rgb(41 37 36 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-900 {
  --tw-border-opacity: 1;
  border-color: rgb(28 25 23 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-stone-950 {
  --tw-border-opacity: 1;
  border-color: rgb(12 10 9 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-100 {
  --tw-border-opacity: 1;
  border-color: rgb(204 251 241 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(153 246 228 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(94 234 212 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-400 {
  --tw-border-opacity: 1;
  border-color: rgb(45 212 191 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-50 {
  --tw-border-opacity: 1;
  border-color: rgb(240 253 250 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-600 {
  --tw-border-opacity: 1;
  border-color: rgb(13 148 136 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-700 {
  --tw-border-opacity: 1;
  border-color: rgb(15 118 110 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-800 {
  --tw-border-opacity: 1;
  border-color: rgb(17 94 89 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-900 {
  --tw-border-opacity: 1;
  border-color: rgb(19 78 74 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-teal-950 {
  --tw-border-opacity: 1;
  border-color: rgb(4 47 46 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-tremor-border {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-tremor-brand {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-100 {
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-300 {
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-400 {
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-50 {
  --tw-border-opacity: 1;
  border-color: rgb(245 243 255 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-600 {
  --tw-border-opacity: 1;
  border-color: rgb(124 58 237 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-700 {
  --tw-border-opacity: 1;
  border-color: rgb(109 40 217 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-800 {
  --tw-border-opacity: 1;
  border-color: rgb(91 33 182 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-900 {
  --tw-border-opacity: 1;
  border-color: rgb(76 29 149 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-violet-950 {
  --tw-border-opacity: 1;
  border-color: rgb(46 16 101 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 249 195 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(250 204 21 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-50 {
  --tw-border-opacity: 1;
  border-color: rgb(254 252 232 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-700 {
  --tw-border-opacity: 1;
  border-color: rgb(161 98 7 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-800 {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-900 {
  --tw-border-opacity: 1;
  border-color: rgb(113 63 18 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-yellow-950 {
  --tw-border-opacity: 1;
  border-color: rgb(66 32 6 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-100 {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-400 {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-50 {
  --tw-border-opacity: 1;
  border-color: rgb(250 250 250 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-500 {
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-600 {
  --tw-border-opacity: 1;
  border-color: rgb(82 82 91 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-700 {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-900 {
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:border-zinc-950 {
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-\\[\\#e20221\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 2 33 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-\\[\\#ffcc33\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 51 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(146 64 14 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(120 53 15 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-amber-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 26 3 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-blue-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 37 84 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-cyan-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 51 68 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 95 70 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-emerald-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 44 34 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 171 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(232 121 249 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 244 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(162 28 175 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 25 143 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(112 26 117 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-fuchsia-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 4 78 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-gray-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-green-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 46 22 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 48 163 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-indigo-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 27 75 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(247 254 231 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 98 18 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(54 83 20 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-lime-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 46 5 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 229 229 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 212 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 163 163 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 82 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(64 64 64 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-neutral-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(154 52 18 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 45 18 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-orange-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(67 20 7 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 24 93 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(157 23 77 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(131 24 67 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-pink-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(80 7 36 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 33 168 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-purple-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 165 165 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-red-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(69 10 10 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(136 19 55 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-rose-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 5 25 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(7 89 133 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-sky-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 47 73 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-slate-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 244 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 229 228 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 211 209 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 162 158 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 249 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(120 113 108 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-stone-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 10 9 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(94 234 212 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(45 212 191 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 118 110 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 94 89 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(19 78 74 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-teal-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 47 46 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-tremor-background {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-tremor-background-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(76 29 149 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-violet-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(46 16 101 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(133 77 14 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 63 18 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-yellow-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(66 32 6 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:bg-zinc-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-\\[\\#e20221\\] {
  --tw-text-opacity: 1;
  color: rgb(226 2 33 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-\\[\\#ffcc33\\] {
  --tw-text-opacity: 1;
  color: rgb(255 204 51 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-100 {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-200 {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-50 {
  --tw-text-opacity: 1;
  color: rgb(255 251 235 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-amber-950 {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-50 {
  --tw-text-opacity: 1;
  color: rgb(239 246 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-blue-950 {
  --tw-text-opacity: 1;
  color: rgb(23 37 84 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-100 {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-200 {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-50 {
  --tw-text-opacity: 1;
  color: rgb(236 254 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-cyan-950 {
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-50 {
  --tw-text-opacity: 1;
  color: rgb(236 253 245 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-emerald-950 {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-100 {
  --tw-text-opacity: 1;
  color: rgb(250 232 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-200 {
  --tw-text-opacity: 1;
  color: rgb(245 208 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-300 {
  --tw-text-opacity: 1;
  color: rgb(240 171 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-400 {
  --tw-text-opacity: 1;
  color: rgb(232 121 249 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-50 {
  --tw-text-opacity: 1;
  color: rgb(253 244 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-500 {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-600 {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-700 {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-800 {
  --tw-text-opacity: 1;
  color: rgb(134 25 143 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-900 {
  --tw-text-opacity: 1;
  color: rgb(112 26 117 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-fuchsia-950 {
  --tw-text-opacity: 1;
  color: rgb(74 4 78 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-50 {
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-100 {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-200 {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-300 {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-50 {
  --tw-text-opacity: 1;
  color: rgb(240 253 244 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-green-950 {
  --tw-text-opacity: 1;
  color: rgb(5 46 22 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-50 {
  --tw-text-opacity: 1;
  color: rgb(238 242 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-indigo-950 {
  --tw-text-opacity: 1;
  color: rgb(30 27 75 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-100 {
  --tw-text-opacity: 1;
  color: rgb(236 252 203 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-200 {
  --tw-text-opacity: 1;
  color: rgb(217 249 157 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-300 {
  --tw-text-opacity: 1;
  color: rgb(190 242 100 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-400 {
  --tw-text-opacity: 1;
  color: rgb(163 230 53 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-50 {
  --tw-text-opacity: 1;
  color: rgb(247 254 231 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-600 {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-lime-950 {
  --tw-text-opacity: 1;
  color: rgb(26 46 5 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-200 {
  --tw-text-opacity: 1;
  color: rgb(229 229 229 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 212 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-400 {
  --tw-text-opacity: 1;
  color: rgb(163 163 163 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-500 {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 82 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgb(23 23 23 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-neutral-950 {
  --tw-text-opacity: 1;
  color: rgb(10 10 10 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-100 {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-200 {
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-50 {
  --tw-text-opacity: 1;
  color: rgb(255 247 237 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(124 45 18 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-orange-950 {
  --tw-text-opacity: 1;
  color: rgb(67 20 7 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-100 {
  --tw-text-opacity: 1;
  color: rgb(252 231 243 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-200 {
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-300 {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-400 {
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-50 {
  --tw-text-opacity: 1;
  color: rgb(253 242 248 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(131 24 67 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-pink-950 {
  --tw-text-opacity: 1;
  color: rgb(80 7 36 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-200 {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-400 {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-50 {
  --tw-text-opacity: 1;
  color: rgb(250 245 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-purple-950 {
  --tw-text-opacity: 1;
  color: rgb(59 7 100 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-100 {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-200 {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-50 {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-red-950 {
  --tw-text-opacity: 1;
  color: rgb(69 10 10 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-100 {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-200 {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-50 {
  --tw-text-opacity: 1;
  color: rgb(255 241 242 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-800 {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-rose-950 {
  --tw-text-opacity: 1;
  color: rgb(76 5 25 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-100 {
  --tw-text-opacity: 1;
  color: rgb(224 242 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-200 {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-400 {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-50 {
  --tw-text-opacity: 1;
  color: rgb(240 249 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-900 {
  --tw-text-opacity: 1;
  color: rgb(12 74 110 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-sky-950 {
  --tw-text-opacity: 1;
  color: rgb(8 47 73 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-50 {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-slate-950 {
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-100 {
  --tw-text-opacity: 1;
  color: rgb(245 245 244 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-200 {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-300 {
  --tw-text-opacity: 1;
  color: rgb(214 211 209 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-400 {
  --tw-text-opacity: 1;
  color: rgb(168 162 158 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 249 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-500 {
  --tw-text-opacity: 1;
  color: rgb(120 113 108 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-600 {
  --tw-text-opacity: 1;
  color: rgb(87 83 78 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-700 {
  --tw-text-opacity: 1;
  color: rgb(68 64 60 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-800 {
  --tw-text-opacity: 1;
  color: rgb(41 37 36 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-900 {
  --tw-text-opacity: 1;
  color: rgb(28 25 23 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-stone-950 {
  --tw-text-opacity: 1;
  color: rgb(12 10 9 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-100 {
  --tw-text-opacity: 1;
  color: rgb(204 251 241 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-200 {
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-300 {
  --tw-text-opacity: 1;
  color: rgb(94 234 212 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-400 {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-50 {
  --tw-text-opacity: 1;
  color: rgb(240 253 250 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(17 94 89 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(19 78 74 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-teal-950 {
  --tw-text-opacity: 1;
  color: rgb(4 47 46 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-tremor-brand {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-tremor-content-emphasis {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-tremor-content-strong {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-100 {
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-200 {
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-300 {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-50 {
  --tw-text-opacity: 1;
  color: rgb(245 243 255 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-900 {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-violet-950 {
  --tw-text-opacity: 1;
  color: rgb(46 16 101 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-100 {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-200 {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-50 {
  --tw-text-opacity: 1;
  color: rgb(254 252 232 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-yellow-950 {
  --tw-text-opacity: 1;
  color: rgb(66 32 6 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-100 {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-200 {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-50 {
  --tw-text-opacity: 1;
  color: rgb(250 250 250 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-700 {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-800 {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:text-zinc-950 {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="selected"]) .ui-selected\\:shadow-tremor-input {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ui-active\\:bg-tremor-background-muted[data-headlessui-state~="active"] {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.ui-active\\:text-tremor-content-strong[data-headlessui-state~="active"] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
:where([data-headlessui-state~="active"]) .ui-active\\:bg-tremor-background-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
:where([data-headlessui-state~="active"]) .ui-active\\:text-tremor-content-strong {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
:is(.dark .dark\\:border) {
  border-width: 1px;
}
:is(.dark .dark\\:border-blue-300) {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-blue-400) {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-blue-900\\/40) {
  border-color: rgb(30 58 138 / 0.4);
}
:is(.dark .dark\\:border-gray-400) {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-gray-900) {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-green-400) {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-orange-400) {
  --tw-border-opacity: 1;
  border-color: rgb(251 146 60 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-purple-400) {
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-red-400) {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity));
}
:is(.dark .dark\\:border-sky-300) {
  --tw-border-opacity: 1;
  border-color: rgb(125 211 252 / var(--tw-border-opacity));
}
:is(.dark .dark\\:bg-blue-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-blue-300\\/20) {
  background-color: rgb(147 197 253 / 0.2);
}
:is(.dark .dark\\:bg-blue-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-blue-500\\/40) {
  background-color: rgb(59 130 246 / 0.4);
}
:is(.dark .dark\\:bg-blue-900\\/40) {
  background-color: rgb(30 58 138 / 0.4);
}
:is(.dark .dark\\:bg-gray-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-700) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-800) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-800\\/90) {
  background-color: rgb(31 41 55 / 0.9);
}
:is(.dark .dark\\:bg-gray-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-950) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-gray-950\\/40) {
  background-color: rgb(3 7 18 / 0.4);
}
:is(.dark .dark\\:bg-green-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-orange-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-purple-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-red-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-sky-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(125 211 252 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:bg-slate-950\\/50) {
  background-color: rgb(2 6 23 / 0.5);
}
:is(.dark .dark\\:bg-transparent) {
  background-color: transparent;
}
:is(.dark .dark\\:bg-opacity-10) {
  --tw-bg-opacity: 0.1;
}
:is(.dark .dark\\:bg-opacity-25) {
  --tw-bg-opacity: 0.25;
}
:is(.dark .dark\\:bg-opacity-30) {
  --tw-bg-opacity: 0.3;
}
:is(.dark .dark\\:stroke-gray-700) {
  stroke: #374151;
}
:is(.dark .dark\\:text-blue-300) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-blue-400) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-400) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-900) {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-green-400) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-orange-400) {
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-purple-400) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-red-400) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white\\/60) {
  color: rgb(255 255 255 / 0.6);
}
:is(.dark .dark\\:text-white\\/70) {
  color: rgb(255 255 255 / 0.7);
}
:is(.dark .dark\\:text-white\\/80) {
  color: rgb(255 255 255 / 0.8);
}
:is(.dark .dark\\:opacity-25) {
  opacity: 0.25;
}
:is(.dark .dark\\:shadow-\\[0_0_0_0\\.2rem_rgba\\(147\\2c 197\\2c 253\\2c 0\\.5\\)\\]) {
  --tw-shadow: 0 0 0 0.2rem rgba(147,197,253,0.5);
  --tw-shadow-colored: 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:placeholder\\:text-tremor-content)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
:is(.dark .dark\\:placeholder\\:text-tremor-content-subtle)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
:is(.dark .before\\:dark\\:border-blue-900\\/40)::before {
  content: var(--tw-content);
  border-color: rgb(30 58 138 / 0.4);
}
:is(.dark .dark\\:before\\:border-b-gray-900)::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(17 24 39 / var(--tw-border-opacity));
}
:is(.dark .before\\:dark\\:bg-gray-900)::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:border-blue-300:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-blue-400:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-blue-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-gray-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-green-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-orange-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-purple-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-red-500:hover) {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
:is(.dark .dark\\:hover\\:border-transparent:hover) {
  border-color: transparent;
}
:is(.dark .dark\\:hover\\:bg-blue-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-gray-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-gray-600:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-gray-800:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-gray-800\\/60:hover) {
  background-color: rgb(31 41 55 / 0.6);
}
:is(.dark .dark\\:hover\\:bg-gray-800\\/70:hover) {
  background-color: rgb(31 41 55 / 0.7);
}
:is(.dark .dark\\:hover\\:bg-gray-800\\/80:hover) {
  background-color: rgb(31 41 55 / 0.8);
}
:is(.dark .dark\\:hover\\:bg-gray-950:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-green-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-orange-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-purple-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-red-500:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
:is(.dark .hover\\:dark\\:bg-gray-700):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
:is(.dark .dark\\:hover\\:bg-opacity-20:hover) {
  --tw-bg-opacity: 0.2;
}
:is(.dark .dark\\:hover\\:text-tremor-content:hover) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-tremor-content-emphasis:hover) {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-white\\/70:hover) {
  color: rgb(255 255 255 / 0.7);
}
:is(.dark .dark\\:hover\\:text-white\\/80:hover) {
  color: rgb(255 255 255 / 0.8);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_0\\.2rem_rgba\\(147\\2c 197\\2c 253\\2c 0\\.5\\)\\]:focus) {
  --tw-shadow: 0 0 0 0.2rem rgba(147,197,253,0.5);
  --tw-shadow-colored: 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(134\\2c 239\\2c 172\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(134,239,172,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(147\\2c 197\\2c 253\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(147,197,253,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(203\\2c 213\\2c 225\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(203,213,225,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(216\\2c 180\\2c 254\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(216,180,254,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(252\\2c 165\\2c 165\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(252,165,165,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[0_0_0_2px_rgba\\(28\\2c 33\\2c 39\\2c 1\\)\\2c 0_0_0_4px_rgba\\(252\\2c 211\\2c 77\\2c 0\\.7\\)\\2c 0_1px_2px_0_rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\]:focus) {
  --tw-shadow: 0 0 0 2px rgba(28,33,39,1),0 0 0 4px rgba(252,211,77,0.7),0 1px 2px 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color), 0 0 0 4px var(--tw-shadow-color), 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:shadow-\\[inset_0_0_0_0\\.2rem_rgba\\(147\\2c 197\\2c 253\\2c 0\\.5\\)\\]:focus) {
  --tw-shadow: inset 0 0 0 0.2rem rgba(147,197,253,0.5);
  --tw-shadow-colored: inset 0 0 0 0.2rem var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
:is(.dark .dark\\:focus\\:outline:focus) {
  outline-style: solid;
}
:is(.dark .dark\\:focus\\:outline-\\[0\\.15rem\\]:focus) {
  outline-width: 0.15rem;
}
:is(.dark .dark\\:focus\\:outline-offset-\\[-0\\.15rem\\]:focus) {
  outline-offset: -0.15rem;
}
:is(.dark .dark\\:focus\\:outline-blue-300:focus) {
  outline-color: #93c5fd;
}
@media (min-width: 0px) {

  .min-\\[0px\\]\\:flex {
    display: flex;
  }

  .min-\\[0px\\]\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 640px) {

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:relative {
    position: relative;
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:left-full {
    left: 100%;
  }

  .sm\\:top-0 {
    top: 0px;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .sm\\:col-span-11 {
    grid-column: span 11 / span 11;
  }

  .sm\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .sm\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .sm\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .sm\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .sm\\:ml-2 {
    margin-left: 0.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[calc\\(100vh-437px\\)\\] {
    height: calc(100vh - 437px);
  }

  .sm\\:h-\\[calc\\(100vh-483px\\)\\] {
    height: calc(100vh - 483px);
  }

  .sm\\:h-\\[calc\\(100vh-529px\\)\\] {
    height: calc(100vh - 529px);
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .sm\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .sm\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .sm\\:grid-cols-none {
    grid-template-columns: none;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:bg-transparent {
    background-color: transparent;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:pl-5 {
    padding-left: 1.25rem;
  }

  .sm\\:shadow-md {
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 768px) {

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-2 {
    right: 0.5rem;
  }

  .md\\:right-4 {
    right: 1rem;
  }

  .md\\:order-1 {
    order: 1;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:order-3 {
    order: 3;
  }

  .md\\:order-4 {
    order: 4;
  }

  .md\\:order-5 {
    order: 5;
  }

  .md\\:order-6 {
    order: 6;
  }

  .md\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .md\\:col-span-11 {
    grid-column: span 11 / span 11;
  }

  .md\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .md\\:m-8 {
    margin: 2rem;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .md\\:mr-4 {
    margin-right: 1rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[175px\\] {
    height: 175px;
  }

  .md\\:h-\\[calc\\(100vh-431px\\)\\] {
    height: calc(100vh - 431px);
  }

  .md\\:h-\\[calc\\(100vh-469px\\)\\] {
    height: calc(100vh - 469px);
  }

  .md\\:h-\\[calc\\(100vh-515px\\)\\] {
    height: calc(100vh - 515px);
  }

  .md\\:h-\\[calc\\(100vh-561px\\)\\] {
    height: calc(100vh - 561px);
  }

  .md\\:\\!max-h-\\[calc\\(100vh-72px\\)\\] {
    max-height: calc(100vh - 72px) !important;
  }

  .md\\:min-h-\\[175px\\] {
    min-height: 175px;
  }

  .md\\:min-h-\\[calc\\(100vh-72px-4rem\\)\\] {
    min-height: calc(100vh - 72px - 4rem);
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-56 {
    width: 14rem;
  }

  .md\\:w-80 {
    width: 20rem;
  }

  .md\\:w-\\[175px\\] {
    width: 175px;
  }

  .md\\:w-\\[255px\\] {
    width: 255px;
  }

  .md\\:w-\\[25rem\\] {
    width: 25rem;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-\\[175px\\] {
    min-width: 175px;
  }

  .md\\:min-w-\\[400px\\] {
    min-width: 400px;
  }

  .md\\:min-w-\\[500px\\] {
    min-width: 500px;
  }

  .md\\:min-w-\\[740px\\] {
    min-width: 740px;
  }

  .md\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .md\\:max-w-\\[500px\\] {
    max-width: 500px;
  }

  .md\\:max-w-\\[750px\\] {
    max-width: 750px;
  }

  .md\\:max-w-\\[calc\\(100\\%-255px\\)\\] {
    max-width: calc(100% - 255px);
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .md\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .md\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .md\\:grid-cols-none {
    grid-template-columns: none;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .lg\\:col-span-11 {
    grid-column: span 11 / span 11;
  }

  .lg\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .lg\\:\\!mr-2 {
    margin-right: 0.5rem !important;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-\\[calc\\(100vh-377px\\)\\] {
    height: calc(100vh - 377px);
  }

  .lg\\:h-\\[calc\\(100vh-423px\\)\\] {
    height: calc(100vh - 423px);
  }

  .lg\\:h-\\[calc\\(100vh-469px\\)\\] {
    height: calc(100vh - 469px);
  }

  .lg\\:h-\\[calc\\(100vh-470px\\)\\] {
    height: calc(100vh - 470px);
  }

  .lg\\:min-w-44 {
    min-width: 11rem;
  }

  .lg\\:min-w-48 {
    min-width: 12rem;
  }

  .lg\\:min-w-56 {
    min-width: 14rem;
  }

  .lg\\:min-w-72 {
    min-width: 18rem;
  }

  .lg\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .lg\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .lg\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .lg\\:grid-cols-none {
    grid-template-columns: none;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
}
@media (min-width: 1280px) {

  .xl\\:order-1 {
    order: 1;
  }

  .xl\\:order-2 {
    order: 2;
  }

  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .xl\\:\\!mb-0 {
    margin-bottom: 0px !important;
  }

  .xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .xl\\:ml-2 {
    margin-left: 0.5rem;
  }

  .xl\\:mr-2 {
    margin-right: 0.5rem;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-\\[calc\\(100vh-377px\\)\\] {
    height: calc(100vh - 377px);
  }

  .xl\\:h-\\[calc\\(100vh-469px\\)\\] {
    height: calc(100vh - 469px);
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:min-w-44 {
    min-width: 11rem;
  }

  .xl\\:min-w-64 {
    min-width: 16rem;
  }

  .xl\\:min-w-72 {
    min-width: 18rem;
  }

  .xl\\:max-w-44 {
    max-width: 11rem;
  }

  .xl\\:max-w-72 {
    max-width: 18rem;
  }

  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:flex-col {
    flex-direction: column;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }
}
@media (min-width: 1536px) {

  .\\32xl\\:flex {
    display: flex;
  }

  .\\32xl\\:h-\\[calc\\(100vh-405px\\)\\] {
    height: calc(100vh - 405px);
  }

  .\\32xl\\:flex-row {
    flex-direction: row;
  }

  .\\32xl\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .\\32xl\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
}
@media (min-width: 1700px) {

  .\\33xl\\:ml-2 {
    margin-left: 0.5rem;
  }

  .\\33xl\\:mr-2 {
    margin-right: 0.5rem;
  }

  .\\33xl\\:mt-0 {
    margin-top: 0px;
  }

  .\\33xl\\:flex {
    display: flex;
  }

  .\\33xl\\:hidden {
    display: none;
  }

  .\\33xl\\:h-\\[calc\\(100vh-377px\\)\\] {
    height: calc(100vh - 377px);
  }

  .\\33xl\\:w-auto {
    width: auto;
  }

  .\\33xl\\:min-w-44 {
    min-width: 11rem;
  }

  .\\33xl\\:min-w-64 {
    min-width: 16rem;
  }

  .\\33xl\\:max-w-44 {
    max-width: 11rem;
  }

  .\\33xl\\:max-w-72 {
    max-width: 18rem;
  }

  .\\33xl\\:flex-row {
    flex-direction: row;
  }

  .\\33xl\\:items-start {
    align-items: flex-start;
  }

  .\\33xl\\:justify-between {
    justify-content: space-between;
  }
}
.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\>button\\:disabled\\>span\\:nth-child\\(2\\)\\]\\:opacity-30>button:disabled>span:nth-child(2) {
  opacity: 0.3;
}
.\\[\\&\\>button\\:disabled\\>span\\:nth-child\\(2\\)\\]\\:opacity-50>button:disabled>span:nth-child(2) {
  opacity: 0.5;
}
.\\[\\&\\>button\\:disabled\\>span\\:nth-child\\(3\\)\\]\\:opacity-30>button:disabled>span:nth-child(3) {
  opacity: 0.3;
}
.\\[\\&\\>button\\:disabled\\>span\\:nth-child\\(3\\)\\]\\:opacity-50>button:disabled>span:nth-child(3) {
  opacity: 0.5;
}
.\\[\\&\\>button\\:disabled\\]\\:bg-transparent>button:disabled {
  background-color: transparent;
}
.\\[\\&\\>button\\]\\:\\!bg-transparent>button {
  background-color: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./public/css/tailwind.css"],"names":[],"mappings":"AAAA;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;EAAA,gBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,mBAA0B;EAA1B,sBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,eAA0B;EAA1B,mBAA0B;EAA1B,sBAA0B;AAAA;;AAA1B;EAAA,8BAA0B;EAA1B,mBAA0B;EAA1B,4CAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wBAA0B;EAA1B,2GAA0B;EAA1B,yGAA0B;EAA1B,iFAA0B;EAA1B;AAA0B;;AAA1B;EAAA,cAA0B;EAA1B;AAA0B;;AAA1B;EAAA;AAA0B;;AAA1B;EAAA,iBAA0B;EAA1B;AAA0B;;AAA1B;EAAA;AAA0B;;AAA1B;EAAA,cAA0B;EAA1B;AAA0B;;AAA1B;EAAA,yDAA0B;EAA1B,wCAA0B;EAA1B,4BAA0B;EAA1B,4BAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,yBAA0B;EAA1B,4BAA0B;EAA1B,wBAA0B;EAA1B,wBAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,gBAA0B;EAA1B,UAA0B;EAA1B,yBAA0B;EAA1B,qBAA0B;EAA1B,sBAA0B;EAA1B,6BAA0B;EAA1B,yBAA0B;UAA1B,iBAA0B;EAA1B,cAA0B;EAA1B,YAA0B;EAA1B,WAA0B;EAA1B,cAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B,iBAA0B;EAA1B;AAA0B;;AAA1B;EAAA;AAA0B;;AAA1B;EAAA;AAA0B;;AAA1B;EAAA,8BAA0B;EAA1B,mBAA0B;EAA1B,4CAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,wBAA0B;EAA1B,2GAA0B;EAA1B,yGAA0B;EAA1B;AAA0B;;AAA1B;EAAA,yBAA0B;EAA1B,8BAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B;AAA0B;;AAA1B;EAAA,yDAA0B;AAAA;;AAA1B;;EAAA;IAAA;EAA0B;AAAA;;AAA1B;EAAA,yDAA0B;AAAA;;AAA1B;;EAAA;IAAA;EAA0B;AAAA;;AAA1B;EAAA,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,yDAA0B;EAA1B,yBAA0B;EAA1B,8BAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;AAAA;;AAA1B;;EAAA;IAAA;EAA0B;AAAA;;AAA1B;EAAA,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,iBAA0B;EAA1B,qBAA0B;EAA1B,eAA0B;EAA1B,gBAA0B;EAA1B,UAA0B;EAA1B,gBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,6BAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B;AAA0B;AAC1B;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,SAA+B;EAA/B;AAA+B;AAA/B;EAAA,QAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,WAA+B;EAA/B;AAA+B;AAA/B;EAAA,cAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B,yEAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,mDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,2DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,yDAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,6CAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,wJAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;;AAE/B;EACE,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AAbA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,yBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,kBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,kBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,gEAcA;EAdA,+DAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sEAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,2BAcA;EAdA;AAcA;AAdA;EAAA,gCAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,4BAcA;EAdA;AAcA;AAdA;EAAA,iCAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,mBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,iBAcA;EAdA,iBAcA;EAdA;AAcA;AAdA;EAAA,iBAcA;EAdA,iBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,iCAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,6BAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,4BAcA;EAdA,wDAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,mDAcA;EAdA,8DAcA;EAdA;AAcA;AAdA;EAAA,6CAcA;EAdA,wDAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,kGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,mDAcA;EAdA,8DAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA,8BAcA;EAdA;AAcA;AAdA;EAAA,8BAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,2GAcA;EAdA,yGAcA;EAdA;AAcA;AAdA;EAAA,2GAcA;EAdA,yGAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,iBAcA;EAdA,iBAcA;EAdA;AAcA;AAdA;EAAA,6BAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,+BAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,0CAcA;EAdA,uDAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,0CAcA;EAdA,uDAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,+CAcA;EAdA,wDAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,sBAcA;EAdA;AAcA;AAdA;EAAA,0BAcA;EAdA,kBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA,sBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA,kBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA,oBAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA,+CAcA;EAdA,wDAcA;EAdA;AAcA;AAdA;EAAA,iGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,iGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,iGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,iGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,iGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,gGAcA;EAdA,2HAcA;EAdA;AAcA;AAdA;EAAA,qDAcA;EAdA,8DAcA;EAdA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA,mBAcA;IAdA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,uBAcA;IAdA,oDAcA;IAdA;EAcA;;EAdA;IAAA,uBAcA;IAdA,2DAcA;IAdA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,6EAcA;IAdA,iGAcA;IAdA;EAcA;;EAdA;IAAA,sBAcA;IAdA,8BAcA;IAdA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,gBAcA;IAdA;EAcA;;EAdA;IAAA,oBAcA;IAdA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,uBAcA;IAdA,sDAcA;IAdA;EAcA;;EAdA;IAAA,uBAcA;IAdA,2DAcA;IAdA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,eAcA;IAdA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,uBAcA;IAdA,sDAcA;IAdA;EAcA;;EAdA;IAAA,uBAcA;IAdA,2DAcA;IAdA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA,uBAcA;IAdA,sDAcA;IAdA;EAcA;;EAdA;IAAA,uBAcA;IAdA,2DAcA;IAdA;EAcA;AAAA;AAdA;;EAAA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;;EAdA;IAAA;EAcA;AAAA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA;AAdA;EAAA;AAcA","sourcesContent":["@import 'tailwindcss/base';\n@import 'tailwindcss/components';\n@import 'tailwindcss/utilities';\n\nbody {\n  line-height: 1.2;\n}\n.no-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.no-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
